export default {
  "The Operator is not registered. Do you want to send a notification to operator to join the platform via email?": 'The Operator is not registered. Do you want to send a notification to operator to join the platform via email?',
  "Do you want to download all attached files in PDF format?": `Do you want to download all attached files in PDF format?`,
    "unknown_error": "Unknown exception",
    "geo_location_error": "Geolocation error",
    "region_not_available": "Region not available",
    "area_too_large": "Area too large",
    "area_too_small": "Area too small",
    "invalid_request_data": "Invalid request data",
    "unknown_error_tt": "When an unhandled exception occurs, can be caused due to any internal system issues",
    "geo_location_error_tt": "Occurs when we are unable to reverse geocode the coordinates to get the address",
    "region_not_available_tt": "When the coordinates of the geofence lie in a region for which we do not have the deforestation models",
    "area_too_large_tt": "When the geofence has a larger area than allowed",
    "area_too_small_tt": "When the geofence has a smaller area than the python API is unable to process",
    "invalid_request_data_tt": "The input data is invalid",
     confirmationTitle: "Confirmation",
     "operatorRegisterConfirmation":"The Operator is not registered. Do you want to send a notification to operator to join the platform via email?",
    satelliteReport: {
        satelliteReport: "Satellite Reports",
        generateReport: "Generate New Report",
        satelliteReportTooltip:
          "Here you can get 5 basic satellite repots for your farms (NDVI, MSAVI, NDRE, RECI, LSWI) to assess the crop health based on Nutrient and Moisture levels",
        operatorName: "Operator Name",
        issueDate: "Issue Date",
        selectFarm: "Select Farm",
        chooseFarm: "Choose Farm",
        chooseZone: "Choose Zone",
        genReport: "Generate Report",
        viewReport: "View Report",
        farmName: "Farm Name",
        allFarms: "All Farms",
        zone: "Zone(s)",
        selectReportType: "Select Report Type",
        report: "Report",
        cropHealth: "Crop Health (NDVI)",
        doi: "Date of Interest",
        dateOfImage: "Date of image with Low Cloud Coverage",
        reciValues: "RECI Values Range from 0 to 10",
        ndviValues: "NDVI Values",
        rangeSubtitle: "The values close to 1 indicates healthier vegetation"
      },
      
      deforestation: {
        riskLevel: "Risk",
        localDbVerificationConfig:"Local Database Verification Config",
        localDBVerification:"Local Database Verification",
        farmAndFarmId:'Farm & FarmID',
        farmerIdCheck:'Farmer ID Check',
        farmNationalStatus:'Farm National Status',
        geofenceOverlapCheck:'Geofence Overlap Check',
        action:'Action',
        edit:'Edit',
        delete:'Delete',
        farmIDStatusDescription:"Farmer ID 'Unmatched' does not make the farm non-complaint",
        attachOneRiskMitigationForAllNonComplaint:"Attach One Risk Mitigation Document For All Non Complaint Farm",
        removeFarmWithIssue:'Remove Farm With Issue',
        farmId:'Farm ID',
        farmerId:'Farmer ID',

        assignedTo: "Assigned To",
        atLeastOperatorOrExporterOrSupplierMustBeselect:"At least One of Operator/Exporter/Supplier should be selected.",
        sendToOperator:"Share With Operator",
        eudrVerificationNo: "Verification Number",
        eudrVerificationNoTT: "Verification Number received from EUDR",
        path: "Path",
        geolocationPrivacyTT: "Toggle to control the confidentiality of location data. Turn ON to mark the location as confidential and restrict its visibility. Turn OFF to make the location publicly accessible.",
        geolocationPrivacy: "Geolocation Privacy",
        privacyEnabled: "Privacy Enabled",
        geolocationPrivacySubHeading: "Toggle to control the confidentiality of location data. Turn ON to mark the location as confidential and restrict its visibility. Turn OFF to make the location publicly accessible.",
        producerData:{
          addProducers:"Add New Producer",
          countryInfo: "Field to input or display the country associated with a producer."
        },
        oneForAllFarms:"One for All Farms",
        oneForEachFarm: "One for Each Farm",
        selectFileToUpload: "Select file to upload data",
        uploadExistingAssessment:"Upload Existing Assessment",
        completeDimitraAssessment:"Assessment by Operator or Supplier",
        assessmentByFarmer:"Assessment by Farmer",
        uploadedToEU: "Uploaded to EU Portal",
        pending: "Pending",
        underReview: "Under Review",
        compliant: "Compliant",
        combinedComplianceLowRisk: "Low Risk",
        combinedComplianceMediumRisk: "Medium Risk",
        mergedComplianceStatus: "Risk Status",
        nonCompliant: "Non-Compliant",
        analyzeDeforestation: "Analyzing Deforestation",
        analyzingWildfireReports: "Analyzing Wildfire Reports",
        analyzingDeforestation: "Analyzing Deforestation",
        readyToProceed: "Ready to Proceed",
        processingFarm: "Processing Farm",
        mitigationRequired: "Mitigation Required",
    
        selectCountry: "Select Country",
        internalReferenceNumberMustBeAlphanumeric :"Internal reference number must be alphanumeric",
        atLeastOneOfSupplierIdOrSupplierNameIsRequired: "At least one of Supplier ID or Supplier Name is required",
        atLeastOneExporterIsRequired: "At least one exporter is required",
        atLeastOneOfOperatorIdOrOperatorNameIsRequired: "At least one of Operator ID or Operator Name is required",
        netMassIsRequired: "Net mass is required",
        netMassMustBeValid: "Net mass must be valid",
        thisFieldIsRequired: "This field is required",
        volumeMustBeNumeric: "Volume must be numeric",
        nameIsRequired: "Name is required",
        firstNameIsRequired: "First name is required",
        lastNameIsRequired: "Last name is required",
        countryIsRequired:"Country is required.",
    
        confirmPdfDownload: "Do you want to download all attached files in PDF format?",
        confirmJsonDownload: "Do you want to download all attached files in JSON format?",
        basicFinalFarmListWithStatus: "Basic final farm list with status",
        detailedInformationIncludingDescriptionOfRiskMitigationActivities: "Detailed information including description of Risk Mitigation activities",
        completeDocumentIncludingRiskMitigationAndAttachedDocuments: "Complete document including Risk mitigation and attached documents",
    
        existing: "Existing",
        survey: "Survey",
    
        operatorInformation: "Operator Information",
        addNewOperator: "Add a New Operator",
    
        reportAddedSuccessfully: "Report added successfully",
        reportUpdatedSuccessfully: "Report updated successfully",
        itemDeletedSuccessfully : "Item deleted successfully.",
        reportDeletedSuccessfully: "Report deleted successfully",
        anErrorOccurredWhileDeletingTheReport: "An error occurred while deleting the report",
    
        
        valueMustBeBetween02And4 : 'Value must be between 0.2 and 4',
    
        complianceRiskWarnings: "Compliance Risk Warnings",
        complianceRiskWarningsInfo: "Displays the section title, indicating that this area focuses on warnings related to compliance risks in the due diligence process.",
        netMassKg: "Net Mass (kg)",
        volumeM3: "Volume (m3)",
        volumeM: "Volume",
        warning: "Warning",
        complete: "Complete",
        undoDelete: "Undo Delete",
    
        verifyingLocationsData: 'Verifying location(s) data...',
        crossCheckingWithProductionPlaces: 'Cross-checking with production places...',
        almostTherePleaseHoldOn : 'Almost there, please hold on...',
        LocationVerifiedSuccessfully:'Location(s) verified successfully!',
        allProductionPlacesAndLocationsHaveBeenConfirmed : "All production places and locations have been confirmed!",
        errorCheckingOverlaps: 'Error checking overlaps.',
        farmIsBiggerThan4HectaresItNeedsToBeAPolygon: 'Farm is bigger than 4 hectares, it needs to be a polygon',
        failedToFetchSettings: 'Unable to fetch settings. Please check your settings or contact support if the issue persists.',
        farmCountryNotDefined: "Farm country not defined.",
        theGeofencesSupposeToBeIn: "The geofence is suppose to be in",
        butItsIn: "but it's in",
        geofenceIsInOcean: "The geofence or part of geofence is in ocean.", 
        
        existingReport: "Existing Deforestation Report",
        dimitraReport: "Dimitra Deforestation Report",
    
        anErrorOccuredWhileFetchingTheDeforestationReport: "An error occured while fetching the deforestation report.",
    
        
    
        veryHighDeforestationProbability: "Very High Deforestation Probability",
        highDeforestationProbability: "High Deforestation Probability",
        mediumDeforestationProbability: "Medium Deforestation Probability",
        lowDeforestationProbability: "Low Deforestation Probability",
        veryLowDeforestationProbability: "Very Low Deforestation Probability",
        zeroNegligibleDeforestationProbability: "Zero/Negligible Deforestation Probability",
        manuallyMitigated: "Manually Mitigated",
    
        
    
        "Zero/Negligible Deforestation Probability":"Zero/Negligible Deforestation Probability",
        "Zero Deforestation Probability": "Zero Deforestation Probability",
        "Low Deforestation Probability": "Low Deforestation Probability",
        "High Deforestation Probability": "High Deforestation Probability",
        "Very Low Deforestation Probability": "Very Low Deforestation Probability",
        "Medium Deforestation Probability": "Medium Deforestation Probability",
        "Very High Deforestation Probability":"Very High Deforestation Probability",
    
        disputeReason: "Dispute Reason",
        disputeStatus: "Dispute Status",
        farmRegId: "Farm Reg. Id",
        productionPlaceId: "Prod. Place ID",
        disputeId: "Dispute ID",
        disputeArea: "Area Size",
        disputeResolution: "Dispute Resolution",
        deforestationComplianceReport: "Deforestation Compliance Reports",
        noDeforestationComplianceReport: "No Deforestation Complianc eReport Found",
        loadingDeforestationComplianceReport:
          "Loading Deforestation Complianc eReport",
        farmName: "Farm Name",
        farmRegistrationId: "Farm Registration ID",
        farmerName: "Farmer Name",
        farmerRegistrationId: "Farmer Registration ID",
        uniqueFarmerId: "Unique Farmer ID",
        uniqueFarmId: "Unique Farm ID",
        farmLocation: "Farm Location",
        area: "Area",
        farmAddress: "Farm Address",
        dateOfRequest: "Date of Request",
        status: "Status",
        settings: "Settings",
        selectDefaultMeasurementUnit: "Select Default Measurement Units",
        selectDefaultMeasurementUnitInfo: "Allows the selection of the default units for measurement, including specifying the unit, setting a maximum limit, and marking it as the default option.",
        maxLimit: "Maximum Limit",
        maxLimitInfo: "Sets the highest allowable value or threshold for a particular parameter.",
        asDefault: "Mark as Default",
        productMass: "Product Mass",
        productMassUnitInfo: "Specifies the unit for measuring the mass of a product.",
        volumeUnitInfo: "Specifies the unit for measuring the volume of a product.",
        operatorInfo: "Refers to an individual or entity responsible for managing or operating a system or process.",
        supplierInfo: "An entity that provides goods or services to another entity.",
        userTypeInfo: "Classifies individuals or entities based on their role or permissions within the system.",
        unit: "Unit",
        userType: "User Type",
        eudrPortalApiKeys: "EUDR Portal API Keys",
        apiKey: "API Key",
        apiSecret: "API Secret",
        headingCreatedSuccessfully: "Heading created successfully",
        headingOrderSuccessfullyUpdated: "Heading Order Successfully Updated",
        headingUpdatedSuccessfully: "Heading updated successfully",
        questionTypeNotDefined: "Question type not defined",
        assessmentRiskMitigationLvl: "Assessment Risk Mitigation Levels",
        assessmentRiskMitigationLvlInfo: "Categorizes the severity of risks associated with land use, forestry practices, and agricultural expansion. These levels help in identifying the potential impact of activities on forested areas and guide the appropriate actions to mitigate negative consequences. Categorizes the levels of risk mitigation strategies, including very high, high, medium, low and zero/negligible.",
    
        dynamicExpiryTime: "Dynamic Expiry Time Period",
        dynamicExpiryTimeInfo: "Sets a time period after which certain data or settings expire automatically.Configures settings related to deforestation reports, including options for auto-renewal.",
        eudrDeforestationAssessment: "EUDR Deforestation Assessment",
        autoRenewalIf: "Auto-Renewal When Added to Due Diligence Report",
        declarationStatements: "Declaration Statements",
        declarationStatementsInfo: "Statements made by the responsible party certifying the accuracy, completeness, and authenticity of the information contained in the report.",
        filterDeclaration: "Filter Declaration Statements",
        declarationTitle: "Declaration Title",
        declarationTitleInfo: "Title or heading for a declaration statement, providing context or summarizing its content.",
        applicableCountry: "Applicable Countries",
        applicableCountryInfo: "Lists the countries to which certain settings or regulations apply.",
        addMore: "Add More",
        autoRenewal: "Auto Renewal",
        createNewAssessment: "Create New Assessment",
        userDimitraAssessment: "Use Dimitra Assessments",
        shipmentList: "List of Shipments",
        generalData: "General Data",
        check: "Check",
    
        eudrComplianceStatus: "EUDR Compliance Status",
        farmLatitude: "Farm Latitude",
        farmLongitude: "Farm Longitude",
        shareQRCode: "Share QR Code",
        copy: "Copy",
    
        allCountries: "All Countries",
        allRegions: "All Regions",
        allFarms: "All Farms",
        allProducer: "All Producers",
        viewCertificate: "View Certificate",
    
        assignmentIssued: "Assignment Issued",
    
        complianceCertification: "Compliance Certification",
        noComplianceCertification: "No Compliance Certification Found",
        loadingComplianceCertification: "Loading Compliance Certification",
    
        eudrForestAssessment: "EUDR Forest Assessments",
        assessmentReport: "Assessment Report",
        downloadPDF: "Download PDF",
        back: "Back",
        farmDetails: "Farm Details",
    
        dimitraFarmId: "Dimitra Farm Id",
        dimitraFermerId: "Dimitra Farmer Id",
        totalGeofenceAreaHA: "Total Geofence Area (AC)",
        forestLossHA: "Forest Loss (AC)",
        forestGainHA: "Forest Gain (AC)",
        forestUnchangedHA: "Forest Unchanged (AC)",
        shareCertificate: "Share Certificate",
        forestUnchanged: "Forest Unchanged",
        forestLoss: "Forest Loss",
        forestGain: "Forest Gain",
        totalGeofenceArea: "Total Geofence Area",
        deforestationProbability: "Deforestation Probability",
        deforestationByYear: "Deforestation by Year",
        colorCode: "Color Code",
        geofenceArea: "Geofence Area",
        percentageOfGeofenceArea: "Percentage of Geofence Area",
        view: "View",
        customization: "Customization",
        recordsPerpage: "Records per Page",
        restoreDefault: "Restore Default",
        apply: "Apply",
        forestAssessmentHelp:
          "If you have questions about this report or need help understanding it, contact us through the Help Desk.",
        overallDeforestationProbability: "Overall Deforestation Probability",
        zeroOrNeglegible: "Zero Or neglegible",
        very_high: "Very High",
        medium: "Medium",
        high: "High",
        allStatus: "All Status",
        low: "Low",
        very_low: "Very Low",
        assessmentIssued: "Assessment Issued",
        certificateIssued: "Certificate Issued",
        assessmentNo: "Assessment No",
        blockchainCertificateDesc:
          "Blockchain Certificate Validation Hash Will Be Available Upon Acceptance of Certificate",
        blockchainValidation: "Blockchain Certificate Validation",
        openBlockchainPage: "Open Blockchain Page",
        clickLinkDesc: "Click on above link to validate certificate on blockchain",
        zeroOrNegligible: "Zero / Negligible",
        veryHigh: "Very High",
        veryLow: "Very Low",
        tooltip: {
          dimitraFarmId:
            "Unique identifier associated with a specific farm in the Dimitra system.",
          farmName: "The designated name of the farm.",
          farmRegistrationId: "Registration number of the farm.",
          farmLocation:
            "Specific geographical coordinates or location of the farm.",
          dimitraFermerId:
            "A distinct identifier linked to an individual farmer within the Dimitra system.",
          farmerName: "Identification of the individual responsible for the farm.",
          farmerRegistrationId: "Registration number of the farmer.",
          assessmentNo: "Unique number assigned to the assessment.",
        },
        darkRed: "Dark Red",
        red: "Red",
        Yellow: "Yellow",
        Orange: "Orange",
        lightBlue: "Light Blue",
        teal: "Teal",
        transparent: "Transparent",
        zeroOrNeglegibleProbability: "Zero/Negligible Deforestation Probability",
        brightRed: "Bright Red",
        orange: "Orange",
        zeroOrNegligibleProbability: "Zero/Negligible Deforestation Probability",
        zeroOrNegligibleRisk: "Zero/Negligible Risk",
        veryLowProbability: "Very Low Deforestation Probability",
        lowProbability: "Low Deforestation Probability",
        mediumProbability: "Medium Deforestation Probability",
        highProbability: "High Deforestation Probability",
        veryHighProbability: "Very High Deforestation Probability",
        riskDetected: "Risk Detected",
        locationName: "Location Name",
    
        approve: "Approve",
        conclude: "Conclude",
        approveMessage:
          "Are you sure you want to approve this report? By approving this report, it will be permanently uploaded to the blockchain. A blockchain link and QR code will be generated, and no further updates or edits can be made. Do you wish to proceed?",
        dueDeligence: "Due Diligence",
        supplierInformation: "Supplier Information",
        addNewSupplier: "Add a New Supplier",
        name: "Name",
        lastName: "Last Name",
        email: "Email",
        phoneNumber: "Phone Number",
        enterSupplierName: "Enter Supplier First Name",
        enterSupplierLastName: "Enter Supplier Last Name",
        enterSupplierFirstName: "Enter Supplier First Name",
        enterOperatorName: "Enter Operator Name",
        enterEmailAddress: "Enter Email Address",
        enterPhoneNumber: "Enter Phone Number",
        // country:"Country",
        // status:"Status",
        whoWillAddPlace: "Who Will Add Production Place Data?",
        companyId: "Company ID",
        activity: "Activity",
        placeOfActivity: "Place of Activity",
        countryOfActivity: "Country of Activity",
        operatorPlaceOfActivity: "Operator Place of Activity",
        operatorCountryOfActivity: "Operator Country of Activity",
        countryOfEntry: "Country of Entry",
        productDetail: "Product Details",
        subProduct: "Sub-Product",
        productionDescription: "Product Description",
        netMass: "Net Mass",
        volume: "Volume",
        scietificName: "Scientific Name",
        commonName: "Common Name",
        eudrDueDeligenceReports: "EUDR Due Diligence Reports",
        EUDRAssessmentReport: "EUDR Assessment Report",
        createNewReport: "Create New Report",
        eudrRefNo: "EUDR Reference No.",
        eudrRefNoInfo: "Functionality to find specific information related to the shipment.",
        statusInfo: "The current status of the shipment in relation to the due diligence report.",
        eudrAndInternalRefNo: "EUDR / Internal Reference No.",
        exporterAndSupplier: "Exporter & Supplier",
        internalRefNo: "Internal Reference No.",
        internalRefNoKenya:"Out-turn No",
        selectOutturn: "Select Out-turn No",
        noOutturnsAvailable: "No out-turns with traceable lots available",
        supplier: "Supplier",
        cooperative: "Cooperative",
        eoriNumber: "EORI Number",
        operator: "Operator",
        quantity: "Quantity",
        product: "Product",
        noOfFarms: "Number of Farms",
        farmsAndQuantity: "Farms & Quantity",
        country: "Country",
        lastUpdated: "Last Updated",
        dueDeligenceStatus: "Due Diligence Status",
        riskStatus: "Risk Status",
        riskStatusHigh: "High Risk",
        riskStatusMedium: "Medium Risk",
        riskStatusZeroNegligible: "Zero/Negligible",
        localComplianceStatus: "Local Compliance Status",
        edurDueDeligenceStatus: "EUDR Due Diligence Status",
        reject: "Reject",
        discard: "Discard",
        saveAndContinueLater: "Save & continue later",
        requestAdditionalInformation: "Request additional information",
        requestAdditionalInformationShort: "Request more info",
        uploadToEudr: "Upload to EUDR",
        submitForApproval: "Submit for Approval",
        submitForApprovalConfirmationPtsi: "Are you sure you want to submit this report for approval? The report will be shared with PTSI once submitted.",
        submitForApprovalConfirmationKenya: "Are you sure you want to submit this report for approval? The report will be shared with Kenya once submitted.",
        editReport: "Edit Report",
        editModeEnabled: "Edit mode enabled. You can now edit the report.",
        failedToEnableEditMode: "Failed to enable edit mode. Please try again.",
        reportEditingRestricted: "Report Editing Restricted",
        reportEditingRestrictedMessage: "This report is currently under review by PTSI and has been assigned to a worker. You cannot make changes while the review process is in progress.",
        reportEditingRestrictedNote: "Please wait until the PTSI team completes their review or unassigns the report.",
        beingEdited: "Being Edited",
        reportBeingEditedTooltip: "This report is currently being edited by the supplier",
        productionPlaces: "Production Places",
        productionPlacesTT: "Locations where goods are manufactured or grown.",
        productionPlacesCountryInfo: "A distinct territorial body with its own government and borders.",
        productionPlacesProducersInfo: "Entity responsible for creating or growing goods.",
        next: "Next",
        dueDeligenceReportCreation: "Due Diligence Report Creation",
        producer: "Producer",
        select: "Select",
        productionPlacesFarmAndFarmId: "Production Place (Farm) & Farm ID",
        producerName: "Producer Name",
        addressOfProduction: "Address of Production",
        type: "Type",
        geofence: "Geofence",
        areaHa: "Area (ha)",
        editGeofence: "Edit Geofence",
        totals: "Totals",
        totalsTT:
          "The 'Totals' section provides a summary of key quantitative metrics for the entire dataset or report. It aggregates data to give users a quick snapshot of the overall metrics, such as total mass of product, total volume of product, area of production place etc., involved in the due diligence report.",
        locationVerification: "Location Verification",
        locationVerificationTT:
          "Refers to the process of confirming and validating the geographical location of production sites as part of due diligence procedures. It involves ensuring that the provided location details, such as coordinates or address, accurately represent the physical location where production activities occur. This verification is crucial for assessing environmental impacts, land use compliance, and the accuracy of reported data within the due diligence report.",
        AnalysisOfDeforestationStatus: "Analysis of Deforestation Status",
        AnalysisOfDeforestationStatusTT:
          "The examination of the current state of deforestation within a specified area, typically conducted to assess environmental impact or compliance with conservation efforts.",
        EUDRDeforestationStatus: "EUDR Deforestation Status",
        productionPlaceStatus: "Status",
        EUDRDeforestationStatusTT:
          "Selection of Deforestation status. High Deforestation Probability : A specific risk assessment category assigned to certain geographical areas based on their likelihood of deforestation or forest degradation. It helps determining the due diligence requirements for operators placing relevant commodities ( cocoa, coffee, etc) or products containing,  made using these commodities on the EU market. Low Deforestation Probability :  A risk assessment category assigned to geographical areas deemed unlikely to experience deforestation or significant forest degradation. This designation influences the due diligence requirements for operators placing relevant commodities or products originating from these areas on the EU market. Zero/ Negligible Deforestation Probability : A very low likelihood or chance of deforestation occurring. It implies that the risk or impact of deforestation is considered extremely small or insignificant.",
        removeAllLowRiskFarm: "Remove all low risk farms",
        removeAllHighRiskFarm: "Remove all high risk farms",
        removeAllMediumRiskFarm: "Remove all medium risk farms",
        attachRiskMigrationDocTT:
          "Indicates the action of associating or linking a single document to all farms identified as having a risk of deforestation, typically for documentation or regulatory compliance purposes.",
        attachRiskMigrationDoc:
          "Attach one risk mitigation document for all high risk farms",
        removedFarms: "Farms removed from the list",
        generateCertificate: "Generate Certificate",
        viewDisputeHistory: "View Dispute History",
        disputeAssessment: "Dispute Assessment",
        reportDetails: "Report Details",
        productionPlace: "Production Place",
        regionalRiskAssessment: "Regional Risk Assessment",
        EUDRDeforestationAssessment: "EUDR Deforestation Assessment",
        complianceStatusReview: "Local DB Compliance",
        complianceStatusReviewTT:
          "Review the compliance traffic light indicator for each production place based on deforestation analysis and IYB regency risk data.",
        complianceStatusReviewDesc:
          "Review each production place's compliance indicator before continuing. Green means compliant, yellow is a warning, and red requires action or removal.",
        complianceTrafficLight: "Risk Indicator",
        viewComplianceIndicator: "View risk indicator details",
        complianceTrafficLightCriticalRiskCount: "{count} farm(s) are Critical Risk.",
        complianceTrafficLightCriticalRiskMustRemove: "These farms cannot proceed — they must be removed before continuing.",
        complianceTrafficLightQuickActions: "Quick Actions",
        complianceTrafficLightRemoveAllCriticalRiskFarms: "Remove All Critical Risk Farms ({count})",
        complianceTrafficLightUploadMitigationDocument: "Upload Mitigation Document",
        complianceTrafficLightBulkUploadHint: "Upload one document to apply mitigation to all farms that still require it.",
        wildfireBulkGenerateButton: "Generate All Wildfire Reports",
        wildfireBulkHint: "Generate the farm-level fire-susceptibility report for every production place in this report at once.",
        wildfireBulkAnalyzing: "Analyzing...",
        wildfireBulkDialogTitle: "Bulk Wildfire Report Generation",
        wildfireBulkConfirmMessage: "This submits every production place in this report ({count} total) for background wildfire fire-susceptibility processing. Large reports can take a while to finish.",
        wildfireBulkStart: "Start",
        wildfireBulkCancel: "Cancel",
        wildfireBulkSubmitting: "Submitting batch...",
        wildfireBulkPolling: "Generating wildfire reports for all production places — this can take a while for large reports...",
        wildfireBulkClose: "Close",
        wildfireBulkErrorColumn: "Error",
        complianceTrafficLightMitigationUploaded: "Mitigation uploaded ✓",
        complianceTrafficLightUploadMitigationRequired: "Upload Mitigation (Required)",
        complianceTrafficLightLegendCriticalRisk: "Critical Risk",
        trafficLightNotAvailable: "Not Available",
        complianceTrafficLightCannotProceed: "Cannot Proceed",
        complianceTrafficLightYesProceed: "Yes, Proceed",
        complianceTrafficLightRemoveAllFarmsTitle: "Remove All {riskLevel} Farms?",
        complianceTrafficLightCannotBeUndone: "This cannot be undone.",
        complianceTrafficLightYesRemove: "Yes, Remove",
        complianceTrafficLightHighRiskCount: "High Risk ({count})",
        complianceTrafficLightMediumRiskCount: "Medium Risk ({count})",
        complianceTrafficLightSelectDocument: "Select document",
        complianceTrafficLightAttachDocument: "Attach Document",
        complianceTrafficLightRevisionRequested: "Revision requested:",
        complianceTrafficLightUploadedDocuments: "Uploaded documents",
        complianceTrafficLightView: "View",
        complianceTrafficLightRemove: "Remove",
        complianceTrafficLightSelectMitigationDocument: "Select mitigation document",
        complianceTrafficLightUpdateDocument: "Update Document",
        complianceTrafficLightUpload: "Upload",
        complianceTrafficLightMediumRiskWarning: "Medium Risk Warning",
        complianceTrafficLightFarmMediumRisk: "Farm {name} is Medium Risk.",
        complianceTrafficLightGotIt: "Got it",
        complianceTrafficLightReadyToProceedTitle: "Ready to proceed?",
        complianceTrafficLightCriticalRiskProceedBody: "You have {count} Critical Risk farm(s) that must be removed before you can proceed to the next step.",
        complianceTrafficLightAllFarmsGoodBody: "All farms look good. Are you sure you want to move to the next step?",
        complianceTrafficLightMitigationFarmNotFound: "Could not find the farm for mitigation resubmit. Please upload documents from the list.",
        EUDRcountry: "The country where the farm is located, linked to the product in the due diligence report. It aids in ensuring geographical traceability as required by EUDR regulations.",
        riskAssessment: "Risk Assessment",
        legalInformation: "Legal Information",
        finalReport: "Final Report",
        editGeolocation: "Edit Geolocation",
        producerCountry: "Producer Country",
        manuallyAddData: "Manually Add Data",
        drawGeofence: "Draw Geofence",
        uploadFile: "Upload File",
        attachRiskMitigationDocumentForAllNonCompliantFarms: "Attach Risk Mitigation Document for All Non-Compliant Farms",
        attachOneRiskMitigationDocumentForAllNonCompliantFarms: "ATTACH ONE RISK MITIGATION DOCUMENT FOR ALL NON-COMPLIANT FARMS",
        fileRequired: "File is required",
        errorMitigatingFarms: "Error mitigating farms",
        submit: "Submit",
        typeyourlocation: "Type your location name/address",
        numberOfPoints: "Number of polygon Points",
        viewGeolocation: "View Geolocation",
        geoLocation: "Geolocation",
        Point: "Point",
        Circular: "Circular",
        Polygon: "Polygon",
        selectFileToUploadData: "Select a file to upload data",
        loadingProductionPlaces: "Loading Production Places",
        remove: "Remove",
        restore: "Restore",
    
        riskMitigation: "Risk Mitigation",
        assessmentRiskMitigation: "Assessment Risk Mitigation",
        riskMitigationHistory: "Risk Mitigation History",
        farmReportNotAvailable: "Farm report is not available",
        signParticipationSurvey : "Would you kindly sign digitally to confirm your participation in this survey?",
        signedBy: "Digitally Signed By:",
        submissionDate: "Submission Date",
        assignTo: "Assigned To",
        eudrReferenceNo: "EUDR Reference No.",
        internalReferenceNo: "Internal Reference No.",
        exporter: "Exporter",
        exporterInfo: "Name of the Exporter. The entity or party responsible for exporting the goods.",
        importer: "Importer",
        importerInfo: "Name of the Importer.The entity or party responsible for importing the goods.",
        shipmentReferenceNo: "Shipment Reference No.",
        shipmentReferenceNoInfo: "A unique identifier used to reference the shipment.",
        ownerShipType: "Ownership Type",
        ownerShipTypeInfo: "The type of ownership associated with the shipment.",
        buyer: "Buyer",
        buyerName: "Buyer Name",
        port_of_origin: "Port of Origin",
        port_of_origin_info: "The location where the shipment originates.",
        port_of_destination: "Port of Destination",
        port_of_destination_info: "The intended destination port for the shipment.",
        no_of_stops: "No of Stops",
        shipping_line: "Shipping Line",
        shipping_line_info: "The company or entity responsible for transporting the shipment.",
        expected_arrival_date: "Expected Arrival Date",
        expected_arrival_date_info: "Anticipated date of arrival for the shipment at its destination.",
        container_id: "Container ID",
        container_id_info: "Unique identifier for the shipping container used in the shipment.",
        container_type: "Container Type",
        container_type_info: "The type or category of shipping container.",
        container_size: "Container Size (ft)",
        container_size_info: "The physical dimensions of the shipping container.",
        container_capacity: "Container Capacity (Tons)",
        container_capacity_info: "The maximum load or capacity of the shipping container.",
        eudr_reference_number: "EUDR Reference Number",
    
        select_default_measurement_units: "Select Default Measurement Units",
        radius: "Radius",
        maximum_limit: "Maximum Limit",
        product_mass: "Product Mass",
        user_type: "User Type",
        eudr_api_keys: "EUDR Portal API Keys",
        api_key: "API Key",
        api_secret: "API Secret",
        assessment_risk_mitigation_levels: "Assessment Risk Mitigation Levels",
        dynamic_expiry_time_period: "Dynamic Expiry Time Period",
        eudr_deforestation_assessment: "EUDR Deforestation Assessment",
        auto_renewal: "Auto-Renewal",
        auto_renewal_when_added_to_the_due_diligence_report:
          "Auto-Renewal When Added to Due Diligence Report",
        declaration_statements: "Declaration Statements",
        filter_declaration_statements: "Filter Declaration Statements",
        showing_all: "Showing All",
        declaration_title: "Declaration Title",
        applicable_countries: "Applicable Countries",
        enabled: "Enabled",
        disabled: "Disabled",
        add_more: "Add More",
        mark_as_default: "Mark as Default",
        actions: "Actions",
        locationVerificationTab:{
          confirmationTitle: "Confirmation",
          confirmationMessage: "You are about to edit the geolocation data for this farm. Please note that any changes to the geolocation will require the re-verification of all related steps, including location verification, deforestation analysis, and regional risk assessment (protected and indigenous area checks). Changes to the farm or farmer name will not require re-verification. Do you wish to proceed?",
        },
        locationModified:{
          headerTitle: "Locations Modified",
          headerDescription: "We have detected the following location(s) have been modified and need to be verified again.",
        },
        processingDialog:{
          modalHeader: "Analyzing Deforestation Status",
          modalDescription_first: "Analyzing EUDR Deforestation Status",
          modalDescription_second: "Your farms are undergoing Automated Deforestation Analysis. You will be redirected to the Due Diligence Reports list page to view the status.",
        },
        processingDialogLocalDB:{
          modalHeader: "Analyzing Local DB Verification",
          modalDescription_first: "Analyzing Local DB Verification Status",
          modalDescription_second: "Your farms are undergoing Automated Local DB Verification Analysis. You will be redirected to the Due Diligence Reports list page to view the status.",
        },
        farmList: {
          title: "EUDR Farm Listing",
          addFarmGeofenceManually: "Add farm geofence manually",
          importGeofenceInBulk: "IMPORT GEOFENCES IN BULK",
          searchPlaceHolder: "Search by farmer name",
          generateCertificate: "Generate Certificate",
          requestAssementReport: "Request Assessment Report",
          producer: "Producer",
          farmNameAndId: "Farm Name & ID",
          addressOfProduction: "Address of Production",
          registrationDate: "Registration Date",
          eudrDeforestationStatus: "EUDR Deforestation Status",
          riskAssessmentStatus: "Risk Assessment Status",
          assessmentTitle: "Assessment Title",
          assessmentDescription: "Assessment Description",
          submissionDate: "Submission Date",
          expiryDate: "Expiry Date",
          assessmentStatus: "Assessment Status",
          downloadAsKmx: "Download as KMX",
          downloadAsKml: "Download as KML",
          downloadAsShp: "Download as SHP",
          downloadAsCsv: "Download as CSV",
          downloadAsExcel: "Download as EXCEL",
          downloadAsPdf: "Download as PDF",
          downloadAsGeoJson: "Download as GeoJSON",
          loadingFarms: "Loading farms",
        },
        dueDeligenceReport: "Public Due Diligence Report Settings",
        allowPublicDownload:
          "Allow public download of farm geofences in GeoJson format",
        showDeforestationSummary:
          "Show EUDR Deforestation Risk Summary by category",
        cancel: "Cancel",
        createShipment: "Create Shipment",
        download: "Download",
        print: "Print",
        loading: "Loading...",
    
        enableAutomaticRiskMitigation: "Enable Automatic Risk Mitigation",
        enableAutomaticRiskMitigationInfo:
          "When enabled, farms with a deforestation status of 'Risk Detected' will be automatically mitigated without manual intervention.",
        deforestationAssessmentRiskToleranceLevel:
          "Deforestation Assessment Risk Tolerance Level",
        deforestationAssessmentRiskToleranceLevelInfo:
          "Use this tool to configure what % of deforestation, for each rating, is acceptable within your Risk Assessment process.Farms with a risk less than or equal to that defined will be considered fit to remain in the DDS, without the need to carry out Risk Mitigation.",
          tons: "Tons",
          
        failedToDeleteQuestion: "Failed to delete question",
        questionOrderSuccessfullyUpdated: "Question order successfully updated",
        assessmentUpdatedSuccessfully: "Assessment updated successfully",
        pleaseWaitCurrentlyUpdatingChecklist: "Please wait, currently updating checklist",
    
        assessmentDetails: "Assessment Details",
        dontShowWarning:"Don't show this warning again.",
        dateSubmitted: "Date Submitted",
        addAComment: "Add a Comment", 
        changeAssignee: "Change Assignee",
        changeStatus: "Change Status",
        assignedUser: "Assigned User",
        selectAssignee: "Select Assignee",
        reply: "Reply",
        discussion: "Discussion",
        attachment: "Attachment",
        sizeKb: "Size (KB)",
        dateAdded: "Date Added",
    
          shipmentStatus:"Shipment Status",
          viewStops:"View Stops",
          enRoute:"En Route",
          delivered:"Delivered",
          failed:"Failed",
          removeEudrDeforestationStatus: "Remove EUDR Deforestation Status",
        riskAssessmentStatusIsRequired: "Risk assessment status is required",
        failedEudrReportDueSetting:'Please ensure the settings for the following properties are configured correctly: Report Expiry, Net Mass, Volume, and Radius',
        requestAdditionalInformationPage:{
          descriptionLabel: "Please provide specific comments or instructions in the text box below. Once submitted, the supplier will be notified and granted access to edit the due diligence report. You will be notified when the supplier updates the report.",
          shareAccessLabel: "The supplier currently has no access to this report. Would you like to share access with the supplier? Please choose how you would like to share access:",
          shareCompleteReportLabel: "Share complete report",
          shareSpecificStepLabel: "Share specific step",
        },
        issueFound: "issue Found",
        unregistered: "Unregistered",
        registered: "Registered",
        circularGeofenceWithAreaGreaterThan4HA: "Circular geofence with area greater than 4 HA",
        riskWarningModal: {
          issuesFound: "{count} issues found",
          currentStep: "Current step: {step}",
          affectedFarm: "Affected farm",
          issue: "Issue",
          farmId: "Farm ID",
          finding: "Finding",
          nextAction: "Next action",
          issueId: "Issue ID",
          lastChecked: "Last checked",
          technicalDetails: "Technical details",
          showing: "Showing {from}–{to} of {total} issues",
          downloadIssueLog: "Download issue log",
          goToStep: "Go to step",
          noIssues: "No issues found",
          loadFailed: "Could not load issue details",
          unnamedFarm: "Unnamed farm",
          searchPlaceholder: "Search farm name or ID…",
          allIssueTypes: "All issue types",
          whatHappened: "What happened",
          whatToDoNext: "What to do next",
          viewStep: "Open step",
          checkHistory: "Check history",
          time: "Time",
          event: "Event",
          result: "Result",
          copyLog: "Copy log",
          logCopied: "Issue log copied",
          noHistory: "No checks have been recorded for this farm yet.",
          technicalDetailsHint: "Identifiers and raw values for support",
          chips: {
            action_required: "Action required",
            needs_review: "Needs review",
            check_failed: "Check failed",
            not_checked: "Not checked",
            not_started: "Not started",
            pending_approval: "Pending approval",
          },
          events: {
            farm_registered: "Farm registered",
            location_checked: "Location check recorded",
            assessment_requested: "Assessment requested",
            result_recorded: "Result recorded",
            mitigation_added: "Mitigation added",
            dispute_resolved: "Dispute resolved",
            assessment_started: "Assessment started",
            assessment_updated: "Assessment updated",
          },
          results: {
            started: "Started",
            completed: "Completed",
            needs_review: "Needs review",
            check_failed: "Check failed",
            pending: "Pending",
            approved: "Approved",
            rejected: "Rejected",
          },
          issues: {
            ocean: {
              title: "Location falls in the ocean",
              finding: "The farm coordinates resolve to a point in the ocean, so the production place cannot be verified.",
              action: "Correct the farm coordinates or boundary in Location Verification.",
            },
            country_mismatch: {
              title: "Country does not match",
              finding: "The farm is located in {detected}, but the report's country of production is {expected}.",
              action: "Fix the farm location, or update the country of production in Report Details.",
            },
            point_over_4ha: {
              title: "Point location over 4 ha",
              finding: "The farm is {area} ha but only has a point location. EUDR requires a polygon for plots larger than 4 ha.",
              action: "Add a polygon boundary for this farm.",
            },
            country_not_defined: {
              title: "Country of production not set",
              finding: "The report has no country of production, so the farm location cannot be checked against it.",
              action: "Set the country of production in Report Details.",
            },
            polygon_overlap: {
              title: "Boundary overlaps another farm",
              finding: "This farm's boundary overlaps: {overlaps}.",
              action: "Check both boundaries and correct the one that is wrong, or remove the duplicate farm.",
            },
            deforestation_risk: {
              title: "Deforestation risk detected",
              finding: "The deforestation assessment returned \"{status}\" for this farm.",
              action: "Review the result and add mitigation or evidence, or remove the farm from the report.",
            },
            assessment_incomplete: {
              title: "Assessment incomplete",
              finding: "The deforestation assessment could not produce a result for this farm (NA).",
              action: "Re-run the deforestation assessment or check the farm boundary.",
            },
            not_assessed: {
              title: "Not assessed yet",
              finding: "No deforestation assessment has been run for this farm.",
              action: "Run the EUDR deforestation assessment for this farm.",
            },
            assessment_missing: {
              title: "Assessment not started",
              finding: "This farm has no response for this assessment yet.",
              action: "Complete the assessment for this farm.",
            },
            assessment_not_approved: {
              title: "Assessment not approved",
              finding: "The assessment for this farm is \"{status}\", not approved.",
              action: "Review and approve the assessment for this farm.",
            },
          },
        },
        statusLegend: "Status Legend",
        statusLegendInfo: "The status legend provides a quick overview of the current status of the due diligence report. It is used to indicate the current status of the report and the actions that can be taken to update the report.",
        sentToExporter: "Sent to Exporter",
        pendingOrNewlyReceived: "Pending/ Newly Received",
        approved: "Approved / On Blockchain",
        updateRequired: "Update Required",
        overdue: "Overdue",
        waitingForPayment: "Waiting for Payment",
        paymentPendingVerificationStatus: "Payment Pending Verification",
        pendingApproval: "Pending Approval",
        approvalStatus: "Approval Status",
        temporaryApproved: "Processing Approval",
        rejected: "Rejected",
        shipmentInProcess: "Shipment In-Process",
        noExporterFound: "No exporter found",
        exporterFoundSuccessfully: "Exporter found successfully",
        exporterAlreadyAdded: "This exporter has already been added",
        addExporter: "Add Exporter",
        addedExporters: "Added Exporters",
        exporterMandatoryNote: "(At least one exporter is required)",
        removeExporter: "Remove exporter",
        enterExporterEmail: "Enter Exporter Email",
        enterExporterEmailKenya:"Enter Agent Email",
        shareReport: "Share Report To Exporter",
        shareReportKenya:"Share Report To Agent",
        exporterInformation: "Exporter Information",
        exporterInformationKenya:"Agent Information",
        pleaseEnterExporterEmail: "Please enter exporter email",
        selectUserToAssign: "Select User to Assign",
        pleaseEnterExporterEmailKenya:"Please enter agent email",
      },

  dueDiligence: {
    commoditiesAffectedByEudr: "Commodities affected by eudr",
    community: "Community",
    deforestationRiskBreakdown: "Deforestation Risk Breakdown",
    downloadFarmGeofences: "Download Farm Geofences",
    dueDiligenceReportInformation: "DUE DILIGENCE REPORT INFORMATION",
    eudrDueDiligenceCompliance: "EUDR Due Diligence Compliance",
    eudrDueDiligenceReportSummary: "EUDR Due Diligence Report Summary",
    farmGeofenceGeojsonFile: "Farm Geofence Geojson File",
    farmLocations: "Farm Locations",
    news: "News",
    publicReportHeroHeading: "Verified {0} Compliance for a {1} Sustainable Future",
    totalFarmsCount: "Total Farms",
    zeroNegligibleRisk: "Zero/Negligible",
    riskDetected: "Risk Detected",
    manuallyMitigated: "Manually Mitigated",
    showFarmWithIssues: "Show farms with issues",
    question: "Question",
    answer: "Answer",
    processing: "Processing",
    attachRiskMitigationDocumentForAllNonCompliantFarms: "Attach Risk Mitigation Document for All Non-Compliant Farms",
        attachOneRiskMitigationDocumentForAllNonCompliantFarms: "ATTACH ONE RISK MITIGATION DOCUMENT FOR ALL NON-COMPLIANT FARMS",
        fileRequired: "File is required",
        errorMitigatingFarms: "Error mitigating farms",
        submit: "Submit",
    ddsReportProcessing:"Your DDS reports are now being processed. You will be notified once they are published on the blockchain.",
    doYouWantToSendToOperator:"Do you want to send this report to the operator?",
    fileAlreadyExists: "File already exists",
    "unknown_error": "Unknown exception",
    "geo_location_error": "Geolocation error",
    "no_processed_images_found": "No processed images found for the provided geofence.",
    "no_processed_images_found_tt": "This error occurs when the system is unable to find any processed satellite images for the specified geofence area. This could be due to various reasons, such as the geofence being located in a remote area with limited satellite coverage, or there may be an issue with the satellite data processing pipeline.",
    "invalid_polygon": "Invalid polygon",
    "invalid_polygon_tt": "This error occurs when the geofence polygon provided is not valid. This could be due to issues such as self-intersecting polygons, incorrect formatting, or other geometric errors that prevent the system from processing the geofence correctly.",
    "region_not_available": "Region not available",
    "area_too_large": "Area too large",
    "area_too_small": "Area too small",
    "invalid_request_data": "Invalid request data",
    "unknown_error_tt": "When an unhandled exception occurs, can be caused due to any internal system issues",
    "geo_location_error_tt": "Occurs when we are unable to reverse geocode the coordinates to get the address",
    "region_not_available_tt": "When the coordinates of the geofence lie in a region for which we do not have the deforestation models",
    "area_too_large_tt": "When the geofence has a larger area than allowed",
    "area_too_small_tt": "When the geofence has a smaller area than the python API is unable to process",
    "invalid_request_data_tt": "The input data is invalid",
       comments: "Comments",
       "commentsRegardingStatement": "Comments regarding the statement",
       "maxCharacterLimit": "Maximum {max} characters allowed",
       enableRiskWarnings: "Enable risk warnings",
        countryOfProduction: "Country of Production",
        countryOfProductionTT: "Country of Production",
        containerId:"Container ID",
        createWithoutRiskAssessment: {
          title: "Create DDS Without Custom Assessment",
          message: "Do you want to create a DDS without adding a Custom Assessment? If so, complaint check rules will skip this step.",
          confirmBtnText: "Yes",
          cancelBtnText: "No",
          doNotShowAgain: "Do not show this message again"
        },
        noAssessmentWarning: "DDS report is missing risk assessments.",
        disputeReason: "Please choose a dispute reason.",
        agricultureAgreement: "Please agree to the term before proceeding further.",
        attachDisputeFile: "Please attach a file before raising dispute.",
        producerTT:
          "Selection of producers or manufacturers involved in the supply chain.",
        supplierInformationTT:
          "Details about the entity providing goods or services.",
        operatorTooltip: "Select the Operator from the pre-registered list in the system",
        operatorSelect:
          "Operator: Choose this option if you, as the operator, will be responsible for adding production place data. You will have the option to provide a list of producers, their farms, and the geolocations within the app.",
        supplierSelect:
          "Supplier: Choose this option if the supplier will be responsible for adding production place data. They will have access to provide the list of producers, their farms, and the geolocations directly within the app.",
        selectWhoWillAddPlaceData: "Select who will add Production Place Data",
        supplierTooltip: "Select the supplier from the pre-registered list in the system.",
        requiredAssessmentTooltip: " Choosing necessary evaluation information.",
        productionPlaceUsingLots:'Select Production Places using Lots',
        
        dueDiligence: "EUDR Due Diligence",
        internalRefNoTooltip: "A unique identifier assigned within an organization or system to reference specific data, transactions, or records for internal tracking and management purposes.",
        eudrRefNoTooltip:"Refers to a unique identifier associated with the European Union's Deforestation Regulation (EUDR), typically used to track and reference compliance-related information within the context of deforestation regulations.",
        companyIdTooltip:"A distinct identifier assigned to a company or organization for identification and tracking purposes, often used within systems, databases, or regulatory frameworks.",
        placeOfActivityTooltip:"Specify the operator's country where activities are conducted and the country where the product will enter the EU market. These details are essential for accurate compliance with EUDR requirements.",
        productDetailToolTip:"Provides detailed information about the product, including its name, net mass, volume, scientific name, and common name.",
        productToolTip:"Name of the product.Refers to a tangible item or commodity produced, manufactured, or traded by a company or organization, often categorized based on its type, characteristics, or purpose.",
        productDescToolTip :"Provides a textual explanation or summary of the characteristics, features, or attributes of a product, aiming to inform users or customers about its nature or functionality.",
        subProductToolTip:"Name of the Sub - Product. Denotes a specific category or subset of a larger product category, typically used for further classification or differentiation within a product hierarchy.",
        netMassTooltTip:"Indicates the weight of a product or item, typically excluding the weight of packaging or other associated materials, often expressed in mass units such as kilograms or pounds.",
        estimatedDdsFeeAmount: "Estimated DDS review fee: {currency} {amount}",
        pricePerTonNote: "{currency} {pricePerTon} per ton",
        volumeToolTip:"Refers to the amount of space occupied by a product or substance, typically measured in cubic units such as cubic meters or cubic feet, used to quantify capacity or quantity in three-dimensional space.",
        scietificNameToolTip:"Taxonomic name of an organism that consists of the genus and species e.g Coffea Arabica, Theobroma cacao L.",
        commonNameToolTip:"A name that is based on the normal language of everyday life E.G. Cocoa, Coffee",
        assementBuilder: "Assessment Builder",
        assessment: "Assessment",
        selectUsers: "Select Users",
        assessmentsList: "Assessments List",
        noOfFarmResponses: "No. of Farm Responses",
        createAssessment: "Create Assessment",
        assessmentName: "Assessment Name",
        assessmentNameInfo: "Functionality to find specific assessments or information.",
        searchAssessment: "Search Assessment",
        selectProcess: "Select Assessment Process",
        assessSettings: "Assessment Settings",
        assessmentTitle: "Assessment Title",
        assessmentTitleInfo: "Name identifying an assessment.",
        assessDescription: "Assessment Description",
        assessDescriptionInfo: "Brief explanation of the assessment's purpose or content.",
        describeAsessment: "Describe the Assessment",
        country: "Country",
        selectCountry: "Select Country",
        expiryTime: "Expiry Time",
        expiryTimeInfo: "Duration until the assessment expires or becomes invalid.",
        noQuestionEachStep: "Number of questions",
        byHeadings: "By Headings",
        assessmentStatus: "Assessment Status",
        multiStepAssess: "Multi-Step Assessment",
        allowAssessment: "Allow assessment to be answered more than once",
        onlyIfExpired: "Only if Expired",
        atAnyTime: "At Any Time",
        editAssessmentDetails: "Edit Assessment Question",
        assessmentDetail: "Assessment Details",
        addQuestion: "Add Assessment Question",
        attachFiles: "Attach Files",
        digitalSignature: "Digital Signature",
        showChecklist: "Show Checklist",
        hideChecklist: "Hide Checklist",
        fileType: "File Type",
        allowMultipleFile: "Allow Multiple Attachments",
        allowComment: "Allow Comments",
        uploadSignatureFile: "Upload Signature File",
        drawSignature: "Draw Signature",
        uploadImage: "Upload Image",
        addSubHeading: "Add sub-heading",
        heading: "Heading",
        headingInfo: "Heading under which the assessment question will be categorized. A dropdown menu to select the heading.",
        subHeading: "Sub-Heading",
        mutiStepHeadingLable: "Create a New step for every Sub-Heading",
        dueDiligenceReports: "Due Diligence Reports",
        dueDiligenceReportsTT:
          "A compilation  of due diligence reports that have been issued, providing information on each report's status or current condition.",
        dueDiligenceReportsInfo:
          "Detailed documentation summarizing the findings and outcomes of the due diligence process. These reports provide insights into the assessment conducted, including any risks identified, compliance status, and recommendations for mitigation or improvement.",
        logistics: "Logistics",
        editSubHeading: "Edit Sub-Heading",
        headingTitle: "Heading Title",
        partOfOrigin: "Port Of Origin",
        destination: "Port Of Destination",
        addStop: "Add a Stop",
        stop: "Stop",
        enterStop: "Enter Stop",
        shipmentList: "List Of Shipments",
        createShipment: "Create New Shipment",
        alreadyInShipment: "Already in Shipment",
        manageFarms: "Manage Farms",
        disputeResolution: "Dispute Resolution",
        disputeAssessment: "Dispute Assessment",
        suppliers: "Suppliers",
        shipments: "Shipments",
        dueDiligenceGuide: "Due Diligence Guide",
        multiStepQuestion1: "Create a New step after",
        questions: "questions",
        questionsInfo: "Quantity of questions in each stage of a multi-step assessment.",
    
        selectRequiredAssessment: "Select Required Assessments",
        filterAssessments: "Filter Assessments",
        dueDiligenceReportCreation: "Due Diligence Report Creation",
    
        dueDiligenceNew: "Due Diligence",
        createNewReport: "Create New Report",
        operator: "Operator",
        supplier: "Supplier",
        supplierTT:
          "Selection of suppliers or manufacturers involved in the supply chain.",
        addMoreAssessments: "Add More Assessments",
        internalReferenceNumber: "Internal Reference No.",
        internalReferenceNumberTT:
          "A reference number or code used internally for organizing and managing due diligence reports.",
        fRinternalReferenceNumberTT:
          "An internal  reference number is a unique identifier assigned to a due diligence report within the system.",
        referenceNumber: "Reference Number",
        domestic: "Domestic",
        import: "Import",
        export: "Export",
        selectProduct: "Select Product",
        selectSubProduct: "Select Sub Product",
        addnewSupplier: "Add New Supplier",
        farmDeforestationReport: "Farm Deforestation Report",
        eudrRefNo:"EUDR Reference Number",
        eudrRefNoTT:"A unique identifier assigned to each due diligence report, facilitating tracking and compliance verification within the European Union Deforestation Regulation (EUDR) framework.",
        addProductionPlaceData: "Add Production Place Data",
        addProductionPlaceDataTooltip: "Choose how you want to add data",
        addProductionPlaceDataDesc:
          "Create your reports by integrating production data from various sources. Select one or multiple sources to compile a comprehensive list of production places for your reports.",
        dimitraApps: "Dimitra Apps",
        addNew: "Add New",
        existingData: "Existing Data",
        manualDataEntry: "Manual Data Entry",
        importFile: "Import File",
        connectedCoffee: "Coffee",
        connectedCacao: "Cacao",
        connectedFarmer: "Coffee",
        manaulProductionPlace: "Manual Production Places Data Entry",
        manaulProductionPlaceTooltip:
          "Process of inputting manufacturing locations manually into the system.",
          farmerRegistrationId  : "Farmer Registration ID",
          farmRegistrationId: "Farm Registration ID",
        addProductionPlace: "Add Production Place",
        producerName: "Producer Name",
        producerNameTT:
          "The name of an individual/ company/ organization which  creates and supplies goods or services",
        producerCountry: "Producer Country",
        producerCountryTT: " The nation of origin where the producer comes from",
        totalArea: "Total Area",
        number: "Number",
        productionPlaceDesc: "Production Place Description",
        area: "Area (ha)",
        type: "Type",
        actions: "Actions",
        selectType: "Select Type",
        importProductionPlace: "Import Production Place",
        importProductionPlaceTT:
          "Allows users to import  production place data using file upload or download options.",
        downloadXLSFormat: "DOWNLOAD XLS FORMAT",
        downloadGeoJsonFormat: "Download GeoJSON Format",
        downloadXMLFormat: "Download XML Format",
        downloadCSVFormat: "Download CSV Format",
        downloadXLSXFormat: "Download XLS Format",
        downloadKMLFormat: "Download KML Format",
        downloadSHPFormat: "Download SHP Format",
        downloadXLSorXLSXFormat: "Download XLS or XLSX Format",
        downloadFileFormatTemplates: "Download file format templates",
        importantNote: "Important Note",
        pleaseProvideFollowing:
          "Please Provide following format (GeoJSON or CSV or XLSX or XLS)",
        existingProductionPlaces: "Existing Production Places",
        existingProductionPlacesTT:
          "Displays a list of existing production places along with details such as the producer's name, country, area, type, and assessment status.",
        productionPlaceAndFarmID: "Production Place & Farm ID",
    
        selectFileToUploadData: "Select file to Upload the Data",
        filterByDate: "Filter By Date",
        dateOfRegister: "Date Of Register",
        dateOfLastReport: "Date of Last Report",
        clearAll: "Clear All",
        addLocation: "Add Location",
    
        pleaseCompleteBeforeProceedingToNext:
          "Please complete the report details section before proceeding to the next step.",
        progressSavedSuccessMsg: "Progress saved successfully!",
        failedSavedProgress: "Failed to save progress. Please try again.",
        failedToCreateReportDetails:
          "Failed to create ReportDetails. Please try again.",
        unExpectedErrorMsg: "An unexpected error occurred. Please try again.",
        selectAssessment: "Select Assessment",
        confirmationPopup: "Confirmation Popup",
        confirmation: "Confirmation",
        approvalConfirmationTitle: "Confirmation",
        approvalConfirmationMessage: "Are you sure you want to approve the selected reports?",
        approvalOnceApprovedTitle: "Once approved",
        approvalVerifiedByPtsi: "Each report will be marked as verified by PTSI.",
        approvalVerifiedByAgent: "Each report will be marked as verified by NACCU.",
        approvalConfirmationMessageShipment: "Are you sure you want to approve the selected shipments?",
        approvalVerifiedByShipment: "This report will be marked as Approved",
        allAssociatedReportsWillBeApprovedShipment: "All associated DDS reports will also be approved",
        approvalVerificationLinksShipment: "Verification links and QR codes will be generated.",
        approvalNoFurtherChangesShipment: "No further changes will be allowed.",
        approvalPublishedToBlockchainShipment: "Shipment & DDS will be published to the Blockchain and the Dimitra public web.",
        allAssociatedReportsWillBeApproved: "All associated reports will be approved",
        approvalVerificationLinks: "Verification links and QR codes will be generated for each report.",
        approvalNoFurtherChanges: "No further changes will be allowed on any approved report.",
        approvalPublishedToBlockchain: "Shipment & Reports will be published to the Blockchain and made available on the Dimitra public web.",
        temporaryApprovalLabel: "Temporary Approval",
        temporaryApprovalDescription: "All non-compliant farms will be marked as manually mitigated for this period. After expiry, they will revert to their original compliance status.",
        approvalExpirationPeriod: "Approval Expiration Period",
        approvalExpirationDays: "Days",
        approvalExpirationWeeks: "Weeks",
        approvalExpirationMonths: "Months",
        approvalExpirationYears: "Years",
        approvalCancelButton: "CANCEL",
        approvalApproveButton: "APPROVE",
        approvalSignatureRequired: "Director / reviewer signature",
        approvalSignatureHint: "Draw or upload your signature. It will appear on the DDS Legal Proof cover page after approval.",
        approvalSignatureHintOptional: "Optional if you already uploaded a signature when verifying payment. Otherwise upload one here for the Legal Proof cover page.",
        approvalSignatureUpload: "Upload signature (PNG or JPG)",
        approvalSignatureRequiredError: "Please add a signature before approving.",
        approvalSignaturePreview: "Signature Preview",
        ptsiAuthorizedSignatoryTitle: "Authorized PTSI Signatory",
        ptsiVerifyOnBehalfHint: "By approving this payment, you confirm verification on behalf of the authorized signatory below. The Legal Proof cover will display the fixed signatory details.",
        ptsiApproveOnBehalfHint: "By approving this report, you confirm on behalf of the authorized signatory below. The Legal Proof cover will display the fixed signatory details.",
        signatoryName: "Name",
        signatoryPosition: "Position",
        signatoryCompany: "Company",
        digitalSignatureLater: "To be added later",
        changeSignature: "Change signature",
        ptsiReviewerSignatureHint: "Add your signature above on behalf of the authorized signatory. It will appear on the DDS Legal Proof cover after approval.",
        verifyingAsReviewer: "Verifying as (logged-in reviewer)",
        reviewerName: "Reviewer name",
        reviewerEmail: "Reviewer email",

        approveShipmentsConfirmation: "Are you sure you want to approve the selected shipments?",
        onceApproved: "Once approved:",
        shipmentMarkedVerified: "Each shipment will be marked as verified by PTSI.",
        verificationLinksGenerated: "Verification links and QR codes will be generated for each shipment.",
        noFurtherChanges: "No further changes will be allowed on any approved shipment.",
        publishedToBlockchain: "Shipments will be published to the Blockchain and made available on the Dimitra public web.",
        assignShipmentDescription: "Please select a user to assign the selected shipments. Once assigned, the user will be notified and granted access to manage these shipments. You can reassign them later if needed.",
        selectUser: "Select User",
        selectUserTooltip: "Choose a user to assign the selected reports to",
        selectUserPlaceholder: "Select a user",
        search: "Search",
        assignButton: "ASSIGN",
        pleaseSelectUser: "Please select a user",
        rejectShipmentsConfirmation: "Are you sure you want to reject the selected shipments?",
        shipmentDataSaved: "These shipments data will be saved after rejection in case you want to review it again later.",
        assignReport: 'Assign Report',
        assignShipment: 'Assign Shipment',
        assignReportConfirmation: 'Are you sure you want to assign the report?',
        assignShipmentConfirmation: 'Are you sure you want to assign the shipment?',

        rejectionWarningTitle: "Warning",
        rejectionConfirmationMessage: "Are you sure you want to reject the selected reports?",
        rejectionReasonLabel: "Reason for rejection",
        rejectionReasonPlaceholder: "Comments",
        rejectionReasonRequired: "Please provide a reason for rejection",
        rejectionDataSaved: "These report data will be saved after rejection in case you want to review it again later.",
        rejectionCancelButton: "CANCEL",
        rejectionConfirmButton: "CONFIRM",
        rejectionNote: "Please Note",

        waitingForPaymentBannerMessage: "This DDS report has pending payment. Share your report with an Exporter and proceed with the pending payment to continue the Approval Process.",
        waitingForPaymentSubmittedTo: "Submitted to {exporters}.",
        paymentResponsibilityTitle: "Become the Payer",
        paymentResponsibilityDescription: "This DDS report has been shared with you as the exporter. Would you like to become the payer for its review fee?",
        paymentResponsibilityWireTransferNote: "Payment for this DDS must be conducted via wire bank transfer.",
        ddsReferenceNo: "DDS Reference No.",
        quantityTons: "Quantity / Tons",
        acceptPaymentResponsibility: "Accept",
        declinePaymentResponsibility: "Decline",
        paymentResponsibilityAccepted: "You are now the payer for this report.",
        paymentResponsibilityDeclined: "You've declined to be the payer for this report.",
        acceptingPaymentResponsibility: "Becoming payer...",
        decliningPaymentResponsibility: "Declining...",
        releasePaymentResponsibility: "Step Down as Payer",
        exitAsPayer: "Exit as Payer",
        releasePaymentResponsibilityConfirm: "Step down as payer for this report? Other shared exporters will be able to become the payer and continue payment.",
        paymentResponsibilityReleased: "You've stepped down as payer. Other exporters can now take over.",
        exporterLockedOutByPayment: "This DDS report is no longer available to you because another exporter became the payer.",
        paymentAssignedToAnotherExporter: "Payment Unavailable",
        paymentUnavailableTooltip: "Payment responsibility has already been accepted by another exporter.",

        reportPayment: "Proceed Payment",
        paymentAmountDue: "Amount Due",
        bankTransferDetails: "Bank Transfer Details",
        uploadReceipt: "Upload Receipt",
        uploadReceiptPlaceholder: "Select a bank transfer receipt file",
        uploadReceiptHint: "Upload a clear image or PDF of your bank transfer receipt.",
        uploadReceiptRequired: "Please upload a payment receipt",
        paymentTransactionNote: "Transaction Note (Optional)",
        paymentTransactionNotePlaceholder: "Add bank reference, transfer date, or other payment notes",
        reportPaymentSubtitle: "Submit your bank transfer receipt for DDS review fee payment",
        submitPayment: "Submit Payment",
        submittingPayment: "Submitting payment...",
        uploadingReceipt: "Uploading receipt...",
        paymentReportedSuccessfully: "Payment reported successfully. PTSI will verify it shortly.",
        paymentReportedByExporterNotice: "This DDS has been shared with an exporter, so the exporter is responsible for reporting payment.",
        verifyPayment: "Verify Payment",
        verifyPaymentReceipt: "Verify Payment Receipt",
        verifyPaymentSubtitle: "Review the invoice details and uploaded payment receipt before confirming payment or sending it back to the exporter.",
        receiptPreview: "Receipt Preview",
        loadingReceipt: "Loading receipt…",
        receiptPreviewUnavailable: "Could not load the receipt preview. Try again or open it in a new tab.",
        receiptPreviewUnsupported: "This file type cannot be previewed here. Open it in a new tab to review.",
        receiptPreviewRetry: "Retry",

        paymentVerified: "Payment Verified",
        paymentRejected: "Payment not received",
        paymentPendingVerification: "Pending Verification",
        paymentPayer: "Payer",
        paymentReceipt: "Receipt",
        paymentRejectionReasonLabel: "Message to exporter",
        paymentRejectionReasonRequired: "Please provide a message for the exporter",
        paymentNotReceivedDefaultMessage: "We could not confirm this bank transfer from the submitted receipt. Please check the payment and re-submit a clear bank receipt so verification can continue.",
        paymentNotReceivedPopupTitle: "Payment not received",
        paymentNotReceivedPopupMessage: "This sends the payment back to the exporter so they can re-submit a receipt. The DDS report itself is not rejected.",
        confirmPaymentNotReceived: "Send to exporter",
        approvePayment: "Confirm",
        rejectPayment: "Payment not received",
        approvingPayment: "Confirming payment...",
        rejectingPayment: "Sending back to exporter...",
        generateInvoice: "Generate Invoice",
        invoiceGeneratedSuccessfully: "Invoice generated successfully.",
        viewInvoice: "View Invoice",
        viewInvoiceAndReceipt: "View Invoice & Receipt",
        submittedPaymentProof: "Submitted Payment Proof",
        receiptSubmittedBy: "Submitted By",
        receiptSubmittedAt: "Submitted At",
        receiptSubmittedByYou: "You",
        receiptSubmittedByAnotherExporter: "Another exporter",
        receiptNotSubmittedYet: "No payment receipt has been submitted yet.",
        openSubmittedReceipt: "Open Submitted Receipt",
        paymentProofNote: "Transaction Note",
        paymentProofHintYou: "This is the payment proof you submitted for this invoice.",
        paymentProofHintOther: "Payment proof was submitted by another exporter who accepted payment responsibility.",

        downloadInvoice: "Download Invoice",
        ddsReviewFeeInvoice: "ID Connect Invoice",
        invoiceHeader: "Invoice Header",
        invoiceNumber: "Invoice Number",
        invoiceDate: "Invoice Date",
        paymentStatus: "Payment Status",
        invoiceGeneratedStatus: "Invoice Generated",
        payerInformation: "Payer Information",
        exporterName: "Exporter Name",
        exporterCompanyId: "Exporter ID / Company ID",
        exporterContact: "Exporter Contact / Email",
        ddsProductInformation: "DDS / Product Information",
        quantityNetMass: "Quantity / Net Mass",
        unit: "Unit",
        unitTon: "Ton",
        pricingInformation: "Pricing Information",
        calculatedAmount: "Calculated Amount",
        paymentInformation: "Payment Information",
        totalAmountPayable: "Total Amount Payable",
        bankAccountInstructions: "Bank Account / Payment Instructions",
        bankTransferPaymentInstructions: "Please transfer the total amount payable to the bank account listed below and upload your payment receipt.",
        paymentDueStatus: "Payment Due Status",
        paymentDue: "Payment Due",
        paymentPaid: "Paid",
        bankDetails: "Bank Details",
        bankName: "Bank Name",
        accountName: "Account Name",
        accountNumber: "Account Number",
        invoiceFooterNote: "This invoice is issued for DDS review fee payment. Please keep a copy for your records.",

        managePaymentTitle: "Manage Payment",
        managePaymentSubtitle: "Complete the payment process for this due diligence report",
        stepReviewDetails: "Review Details",
        stepReviewDetailsDesc: "Check invoice information",
        stepConfirmResponsibility: "Become the Payer",
        stepConfirmResponsibilityDesc: "Confirm you'll pay this report",
        stepMakePayment: "Make Payment",
        stepMakePaymentDesc: "Upload bank receipt",
        stepComplete: "Complete",
        stepCompleteDescPending: "Payment under review",
        stepCompleteDescDone: "Payment successful",
        invoiceDetailsHint: "Please review the invoice information before proceeding.",
        confirmResponsibilityHint: "Confirm that you'll be the one paying for this report.",
        acceptResponsibilityStatement: "By becoming the payer, you confirm that you will make the payment and upload the bank transfer receipt.",
        acceptResponsibilityNote: "This report will be assigned to you for payment.",
        acceptResponsibilityCheckboxLabel: "I agree to become the payer for this report.",
        continueToPayment: "Continue to Payment",
        continueToAccept: "Continue to Become Payer",
        reviewAcceptNote: "You'll be asked to become the payer next. Once confirmed, other exporters shared on this report will no longer be able to take over payment.",
        nextUploadReceipt: "Next: Upload Receipt",
        continue: "Continue",
        back: "Back",
        selectPaymentMethod: "Select Payment Method",
        selectPaymentMethodHint: "Choose how you want to pay the ID-Connect.io service fee.",
        paymentMethodBank: "Bank Transfer",
        paymentMethodBankDesc: "Transfer to our BCA account, then upload your receipt.",
        paymentMethodMidtrans: "MIDTRANS",
        paymentMethodMidtransDesc: "Pay online via bank transfer, QRIS, or card.",
        midtransComingSoon: "Coming Soon",
        midtransComingSoonHint: "Online payment via MIDTRANS will be available soon. Please use bank transfer for now.",
        paymentPurpose: "Payment Purpose",
        bankBranch: "Bank Branch",
        swiftBicCode: "SWIFT / BIC Code",
        howToPay: "How to Pay",
        howToPayMobile: "Mobile Banking App",
        howToPayInternet: "Internet Banking",
        howToPayAtm: "ATM Transfer",
        internationalWireNote: "Overseas payments: use SWIFT code CENAIDJA and choose OUR fee mode so the full invoice amount is received. Send the TT / SWIFT receipt after transfer.",
        transferThenUploadHint: "Transfer the amount using the bank details below, then upload a clear receipt.",
        uploadBankReceiptTitle: "Upload Bank Transfer Receipt",
        uploadBankReceiptHint: "Please upload a clear image or PDF of your bank transfer receipt.",
        dragDropFileHere: "Drag and drop your file here",
        clickToBrowse: "or click to browse",
        supportedFormatsMax5MB: "Supported formats: PDF, JPG, PNG (Max 5 MB)",
        submitForVerification: "Submit for Verification",
        paymentTypeLabel: "Payment Type",
        paymentTypeDdsReviewFee: "DDS Review Fee",
        paymentStatusTitle: "Payment Status",
        paymentStatusHintWaiting: "Please complete the payment to proceed.",
        paymentStatusHintReported: "Your payment is under review.",
        paymentStatusHintVerified: "Your payment has been verified.",
        paymentStatusHintRejected: "We could not confirm this payment. Please review the note and re-submit your receipt.",
        paymentInstructionsTitle: "Payment Instructions",
        paymentInstructionsStep1Title: "Transfer the amount",
        paymentInstructionsStep1Desc: "Send {amount} to our bank account",
        paymentInstructionsStep2Title: "Upload receipt",
        paymentInstructionsStep2Desc: "Upload a clear image or PDF of your bank transfer receipt",
        paymentInstructionsStep3Title: "Wait for verification",
        paymentInstructionsStep3Desc: "Our team will verify your payment and update the status.",
        viewBankDetails: "View Bank Details",
        needHelpTitle: "Need Help?",
        needHelpDesc: "If you have any issues with the payment process, please contact our support team.",
        contactSupport: "Contact Support",
        paymentSubmittedTitle: "Payment Submitted",
        paymentSubmittedMessage: "Your bank transfer receipt has been submitted and is now under review. We'll update the status once it's verified.",
        paymentVerifiedMessage: "Your payment has been verified. This report is now compliant.",
        paymentRejectedMessage: "We could not confirm this payment from the receipt you submitted. Please review the note below and re-submit a valid bank receipt.",
        reUploadReceipt: "Re-upload Receipt",
        resubmitPayment: "Re-submit Payment",

        ddsPaymentPricingTitle: "DDS Payment Pricing",
        ddsPaymentPricingSubtitle: "Set the price per ton charged for reviewing a DDS, by product and country. Pricing is matched against the reporting organization's registered country. Reports for products without a configured price skip the payment step.",
        pricePerTon: "Price per Ton",
        ddsPricePerTon: "DDS Price per Ton",
        currency: "Currency",
        pricingCountry: "Country",
        pricingProduct: "Product",
        pricingActions: "Actions",
        addPricing: "Add Pricing",
        updatePricing: "Update Pricing",
        pricingSavedSuccessfully: "Pricing saved successfully.",
        deletePricing: "Delete Pricing",
        pricingDeleteConfirm: "Are you sure you want to delete this pricing setting?",
        pricingDeletedSuccessfully: "Pricing setting deleted successfully.",
        noPricingSettingsConfigured: "No pricing settings configured yet.",
        organizationCountryLabel: "Organization Country",
        organizationCountrySubtitle: "The registered country for your organization. Used to match DDS payment pricing configured by country.",
        organizationCountrySavedSuccessfully: "Organization country saved successfully.",
        enterPricePerTon: "Enter Price per Ton",
        selectCurrency: "Select Currency",
        saveAndConfirmationMessage: "Are you sure you want to save the changes?",
        confirmDownload:
          "Do you want to download all attached files in PDF format?",
        supplierNotRegisterContent:
          "The Supplier is not registered. Do you want to send a notification to supplier to join the platform via email?",
    
        confirmationPopupMsg:
          "Are you sure you want to discard this report? Confirming this action will result in permanent deletion.",
        warningPopup: "Warning Popup",
        warningPopupMsg:
          "Are you sure you want to reject this report? Please note : This report data will be saved after rejection in case you want to review it later.",
        automatedDeforestationProgressText:
          "Automated deforestation check of geofence data and identification of critical cases",
        someRiskWereIdentifiedText:
          "Please review the following production place deforestation risk assessment and mitigate accordingly before proceeding.",
        reviewProductionPlaceRiskAdvisory:
          "Please review the following production place deforestation risk assessment and mitigate accordingly before proceeding.",
        riskAdvisoryMitigationRecommended: "Risk Advisory — Mitigation Recommended",
        riskAdvisoryMitigationRecommendedBody:
          "{count} farm(s) have been flagged with some risk that may cause delays during approval. Mitigation documentation is not required but is strongly recommended before submitting.",
        riskAdvisoryMitigationRequired: "Risk Advisory — Mitigation Required",
        riskAdvisoryMitigationRequiredBody:
          "{count} farm(s) have high-risk findings that must be resolved before this DDS can be submitted. You cannot proceed until mitigation documentation has been uploaded for all high-risk farms.",
        uploadMitigationDocumentationRecommended: "Upload Mitigation Documentation (Recommended)",
        uploadMitigationDocumentation: "Upload Mitigation Documentation",
        requestToUploadMitigation: "Request to Upload",
        requestAdditionalInformationBatchHint:
          "Sending this request will notify the cooperator once with all {count} queued production place(s) listed below.",
        requestAdditionalInformationBatchEmptyHint:
          "You can queue individual farms using Request to Upload or Request Revision, then send one accumulated notification from here.",
        supplierNotFoundForRequest:
          "Unable to resolve the supplier for this report. Please refresh the page and try again.",
        farmsPendingRevisionBatch: "Production Places Queued for Update",
        farmsPendingRevisionBatchHint:
          "These farms were queued from individual review actions. One consolidated email and notification will be sent when you submit.",
        revisionRequired: "Revision Required",
        uploadRequired: "Upload Required",
        attachReferenceDocuments: "Attach Reference Documents",
        attachReferenceDocumentsHint: "Optional. Upload supporting documents or templates for the supplier to review when submitting mitigation evidence.",
        selectDocumentsToAttach: "Select documents to attach",
        attachedDocuments: "Attached Documents",
        approveMitigationWithoutDocumentsNote:
          "One or more selected farms have no uploaded mitigation documents. You can still approve them with temporary mitigation status.",
        approveMitigationWithoutDocumentsPermanentNote:
          "One or more selected farms have no uploaded mitigation documents. They will be permanently marked as Manually Mitigated.",
        approveMitigationEvidenceTitle: "Approve Mitigation Evidence",
        approveMitigationEvidenceButton: "Approve Evidence",
        approveMitigationEvidenceIntroSingle: "Approve evidence for {name}.",
        approveMitigationEvidenceIntroBulk: "Approve evidence for {count} farms.",
        approveMitigationEvidencePermanentSummary:
          "The farm(s) will be permanently marked as Manually Mitigated.",
        approveMitigationEvidenceTemporarySummary:
          "The farm(s) will be marked as Manually Mitigated for the selected period, then revert to their original risk status.",
        approveMitigationEvidenceRevertNote:
          "After this period, each farm returns to its previous compliance status (e.g. Medium Risk).",
        approveMitigationNoDocumentsWarningTitle: "Missing mitigation documents",
        proceedWithoutMitigation: "Proceed Without Mitigation",
        cancelAndCreateNewDds: "Cancel and Create a New DDS",
        legendMitigationRecommended: "Mitigation Recommended",
        legendMitigationRequired: "Mitigation Required",
        legendMitigationUploaded: "Mitigation Uploaded",
        localDbAndEudrMitigationTitle: "Local DB Compliance & EUDR Deforestation Mitigation",
        localDbAndEudrMitigationSubtitle:
          "Review supplier evidence for medium and high risk farms flagged under Local DB Compliance and EUDR Deforestation Status",
        eudrAssessmentCannotProceedTitle: "Unable to Proceed",
        eudrAssessmentRiskDetectedInPlaces:
          "Risk detected in {count} production place | Risk detected in {count} production places",
        eudrAssessmentCannotProceedSubtext:
          "These production places must reach Zero/Negligible or Manually Mitigated status before you can continue to the next step.",
        eudrAssessmentCannotProceedHelperTitle: "How to resolve risk detected farms",
        eudrAssessmentCannotProceedStep1:
          "Locate the affected production place in the table and open the actions menu (clipboard icon) on the right.",
        eudrAssessmentCannotProceedStep2:
          "Select Manual Risk Mitigation and upload supporting documents for your risk review.",
        eudrAssessmentCannotProceedStep3:
          "Once mitigation is approved, the EUDR status will update to Manually Mitigated and you can proceed.",
        eudrAssessmentCannotProceedStep4:
          "If you disagree with the deforestation assessment, raise a Disputes request from the same actions menu.",
        eudrAssessmentCannotProceedTimelineNote:
          "Please note: Manual Risk Mitigation reviews are usually completed within a few business days. Dispute resolution and reassessment may take several days to a week or longer, depending on review volume. You will be notified once a decision is made and can continue after the status is updated.",
        eudrAssessmentCannotProceedGoBack: "Go Back",
        productionPlacesCount: "production place(s)",
    
        riskAssessmentAndMitigation: "Risk Assessment & Mitigation",
        riskAssessmentAndMitigationTT:
          "Identifying potential risks and implementing strategies to minimize their impact or likelihood of occurrence. It includes evaluating hazards, analyzing their potential consequences, and developing plans to address or mitigate them effectively.",
        riskAssessmentStatus: "Risk Assessment Status",
        riskAssessment: "Risk Assessment",
        uploadRiskAssessment: "Upload Risk Assessment",
        uploadRiskAssessmentTT: "Action to upload a risk assessment document.",
        manualFillOutAssessment: "Manually fill out assessment",
        manualFillOutAssessmentTT:
          "Action to complete an assessment form manually.",
        criteria : "Criteria (b, f and g)",
        downloadAssessmentForm: "Download Assessment Form",
        addSignature: "Add Signature",
        createNewDueDiligenceProgress: "Create New Due Diligence Process",
        usageLimits: "Usage Limits",
        usageLimitsTT:
          "Refer to the predefined restrictions or quotas set on the number of times these reports and assessments can be accessed, generated, or utilized within a given timeframe. These limits are established to manage resource allocation, ensure fair usage, and maintain system performance.",
        totalReports: "Total Reports",
        eudrDeforestationAssessments: "EUDR Deforestation assessments",
        totalAssessments: "Total Assessments",
        listOfFarms: "List of Farms",
        listOfFarmsTT:
          " A comprehensive display of farms, including information such as the production location, producer's name, country of operation, land area in hectares, type of farming activities, assessments related to deforestation, and evaluations of potential risks associated with the farm operations.",
        listOfFarmsInfo:
          "A comprehensive display of farms, including information such as the production location, producer's name, country of operation, land area in hectares, type of farming activities, assessments related to deforestation, and evaluations of potential risks associated with the farm operations.",
        perMonth: "Per Month",
        share: "Share",
        viewReport: "View Report",
        viewReportSummary: "View Report Summary",
        copy: "Copy",
        copyAndCreateNew: "Copy and Create New",
        listOfSupplier: "List of Suppliers",
        addNewSupplier: "Add new suppliers",
        editSupplier: "Edit Supplier",
        supplierName: "Supplier Name",
        listOfOperators: "List of Operators",
        addNewOperator: "Add New Operators",
        operatorName: "Operator Name",
        operators: "Operators",
        editOperator: "Edit Operator",
        eoriNumber: "EORI Number",
        isoCode: "ISO Code",
        enterEmailAddress: "Enter email address",
        enterFirstName: "Enter first name",
        enterLastName: "Enter last name",
        enterEORINumber: "Enter EORI Number",
        myFarms: "My Farms",
        listOfProducers: "List of Producers",
        producers: "Producers",
        addNewProducer: "Add New Producer",
        lastAssessment: "Last Assessment",
        noOfFarms: "No. of Farms",
        shipmentID: "Shipment ID",
        noOfReports: "No. of Reports",
    
        operatorData: "Operator Data",
        supplierData: "Supplier Data",
        supplierDataTT: "Information about the supplier.",
        operatorDataTT: "Information about the operator.",
    
        reportSummary: "Risk Summary",
        reportSummaryTT: "Brief overview of the report.",
        totalNoOfGeofencePolygon: "Total Number of Geofence Polygons",
        totalNoOfGeofencePolygonTT: "Total count of geofence polygons.",
        totalNoOfGeofencePoint: "Total Number of Geofence Points",
        totalNoOfGeofencePointTT: "Total count of geofence points.",
        totalNoOfFarms: "Total Number of Farms",
        totalNoOfFarmsTT: "Count of total farms.",
        totalAreaFinalReport: "Total Area (ha)",
        totalNoOfDeforestation: "Total Number of Deforestation",
        totalNoOfDeforestationTT: "Total count of deforestation assessments.",
        totalNoOfHighDeforestation: "Total Number of High Deforestation",
        totalNoOfHighDeforestationTT: "Total Count of high deforestation farms.",
        totalNoOfRiskAssessments: "Total Number of Risk Assessments",
        totalNoOfRiskAssessmentsTT: "Total count of risk assessments.",
        totalNoOfLocalDbHighRiskFarms: "Total Number of High Risk (Local DB Compliance)",
        totalNoOfLocalDbHighRiskFarmsTT: "Count of production places with high local database compliance risk.",
        totalNoOfLocalDbMediumRiskFarms: "Total Number of Medium Risk (Local DB Compliance)",
        totalNoOfLocalDbMediumRiskFarmsTT: "Count of production places with medium local database compliance risk.",
    
        productDetail: "Product Details",
        productDetailTT: "Information about the product.",
    
        product: "Product",
        productTT:
          "Name of the product.Refers to a tangible item or commodity produced, manufactured, or traded by a company or organization, often categorized based on its type, characteristics, or purpose.",
        productDescription: "Product Description",
        productDescriptionTT:
          "Provides a textual explanation or summary of the characteristics, features, or attributes of a product, aiming to inform users or customers about its nature or functionality.",
        netMass: "Net Mass",
        netMassTT:
          "Indicates the weight of a product or item, typically excluding the weight of packaging or other associated materials, often expressed in mass units such as kilograms or pounds.",
        volume: "Volume",
        volumeTT:
          "Refers to the amount of space occupied by a product or substance, typically measured in cubic units such as cubic meters or cubic feet, used to quantify capacity or quantity in three-dimensional space.",
        scientificName: "Scientific Name",
        scientificNameTT:
          "Taxonomic name of an organism that consists of the genus and species e.g Coffea Arabica, Theobroma cacao L.",
        commonName: "Common Name",
        commonNameTT:
          "A name that is based on the normal language of everyday life E.G. Cocoa, Coffee",
    
        productionPlaces: "Production Places",
        productionPlacesTT:
          "Displays a list of existing production places along with details such as the producer's name, country, area, type, and assessment status.",
    
        selectProductionPlacesUsingLots: "Select Production Places Using Lots",
        SelectProductionPlacesUsingFarms : "Select Production Places Using Farms",
    
        areaForPointGeofence: "Area for Circular Geofence",
        accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "According to EUDR, farms with less than 4 hectares do not require a polygon.",
        circularAreaEquivalent: "In these cases, we will use a circular area equivalent to the farm size, with the provided GPS point as the center to check for deforestation.When the size of the farm is not provided, we will default to 4 hectares.",
        ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow: "If the farms are smaller, please enter the standard size in the field below.",
        defaultCircularGeofence:"Farms without a geofence or without information about their size will be assigned a default circular geofence of 4 hectares. If the average farm size is smaller than 4 hectares, please change the default size by clicking the 'Edit' button below.",
        defaultAreaValueSpecified: "Farms with no geofence or area will receive the default area value specified below and will be assigned a circular geofence with a circular radius.",
        uploadFileBeingProcessed: "Your uploaded files are being processed. You will be redirected to the Due Diligence Reports list page to view the status in", 
        processingLocations: "Processing Locations",
    
        lotId: "Lot ID", 
        lotIds: "Lot IDs",
        qualityGade: "Quality Grade",   
    
        onlyShowFarmsWithIssues: "Only show farms with issues",
    
        analyzingStatus: "Analyzing Deforestation Status",
        analyzingDesc: "Your farms are undergoing Automated Deforestation Analysis. You will be redirected to the Due Diligence Reports list page to view the status.",
        readyToProceed: "Ready To Proceed",
        mitigationRequired: "Mitigation Required",
        viewSummary: "View Summary",
        viewAssessment: "View Assessment",
        disputes: "Disputes",
        manualRiskMitigation: "Manual Risk Mitigation",
        veryHighProbability: "Very High Probability",
        highProbability: "High Probability",
        mediumProbability: "Medium Probability",
        lowProbability: "Low Probability",
        veryLowProbability: "Very Low Probability",
        zeroProbability: "Zero/Negligible Probability",
        manualMitigated: 'Manually Mitigated',
        disputeDesc: "Click on one of the dispute requests below to see more details.",
        geofenceColorCode: "Geofence Color Code:",
        noDisputeHaveSubmitted: "No disputes have been submitted yet",
        disputeDetails: "Dispute Details",
        chooseDisputeReason: "Choose Dispute Reason",
        pleaseAttachDoc: "Please attach documents/or photos to support your answer.",
        additionalNotes: "Additional Notes",
        aggrementStatement: "I understand that the affected land will not be used for agriculture in the next years.",
        addGeofenceRadius: "Add Geofence Radius",
        totalGeofenceRadius: "Total Geofence Radius is",
        resolutionHistory: "Resolution history",
        proceed: "Proceed",
        wildFire: "Wild Fire",
        controlledFire: "Controlled Fire",
        clearingForAgriculture: "Clearing for agriculture and/or livestock",
        pestAndDiseases: "Pest and Diseases",
        naturalChangesInCanopy: "Natural changes in canopy (like seasonal leaf drop)",
        strongWinds: "Strong winds (like hurricanes or tornados)",
        otherNaturalDisasters: "Other natural disasters",
        flooding: "Flooding",
        logging: "Logging",
        infrastructure: "Infrastructure",
        urbanization: "Urbanization",
        landGrabbingOrPopulationPressure: "Land grabbing, off-farmer subsistence farming or population pressure",
        mining: "Mining",
        plantationForestBeforeDeadline: "It's a plantation forest or a wooded land, but the primary forests or naturally regenerating forests was converted into plantation forests or into other wooded land before the deadline (31 December 2020)",
        convertedToPlantationForest: "The primary forests or naturally regenerating forests was converted into plantation forests or into other wooded land",
        cultivatedAreaBeforeDeadline: "It is a cultivated area, and it was not deforested after the deadline (31 December 2020)",
        forestStillPreserved: "There is a forest in the area, but it has not been deforested and it's still preserved",
        downloadAsPDF: " Download as PDF",
        downloadAsJSON: "Download AS JSON",
        downloadOptions: "Download Options",
        productionPlacesHighDeforestationProbability: "production places have high deforestation probability",
        geofenceHighDeforestationProbability: "Geofence has high deforestation probability",
        EUDRReferenceNumber: "EUDR Reference Number",
        totalNoOfRiskAssessment: "Total Number of Risk Assessments",
        totalNoOFDeforestationAssessments: "Total Number of Deforestation Assessments",
        totalNoOfGeofencePoints: "Total Number of Geofence Points",
        totalNoOfGeofencePolygons: "Total Number of Geofence Polygons",
        dueDiligenceReportStatus: " Due Diligence Report Status",
        nonComplianceReasons: "Reasons for non-compliance",
        nonComplianceDeforestationStatus: "Production places with a non-zero deforestation status",
        nonComplianceRiskAssessmentStatus: "Production places with a non-zero risk assessment status",
        nonComplianceLargerThanFourHectares: "Production places larger than 4 hectares",
        nonComplianceFarmInOcean: "Production places located in the ocean",
        nonComplianceFarmInDifferentLocation: "Production places located in a different location",
        nonComplianceGeofenceNotChecked: "Production places whose geofence has not been checked yet",
        declarationStatement: "Declaration Statement by Operator",
        undoDelete: "Undo Delete",
        analyzingDeforestation: "Analyzing Deforestation",
        processingFarm: "Processing Farm",
        operatorDecleration: "Declaration Statement by Operator",
        operatorDeclerationTT: "Statement of declaration by the operator.",
        supplierDecleration: "Declaration Statement by Supplier",
        supplierDeclerationTT: "Statement of declaration by the supplier.",
        pleaseSelectAtLeastOneItem : "Please select at least one item.",
    
        pleaseSelectAtLeastOneSource : "Please select at least one source.",
        invalidFileFormatPleaseUploadValidFile : "Invalid file format. Please upload a .xml, .kml, or .geojson file.",
        pleaseUploadAValidFile : "Please upload a valid file.",
        fileUploadedDuccessfully : "File uploaded successfully!",
        anErrorOccured: "An error occurred.",
        successfullyUpdatedDefaultFarmArea : "Successfully updated default farm area.",
        pleaseAddProductionPlacesData : "Please add Production Places data",
        failedToFetchSettings : "Unable to fetch settings. Please check your settings or contact support if the issue persists.",
        updatedDueDiligenceReport : "Updated Due Diligence Report",
        updatedDueDiligenceStatus: "The Due Diligence status has been updated successfully.",
        failedToWriteDeforestationDataToBlockchain : "Failed to write deforestation data to blockchain, please try again.",
        countryIsRequired: "Country is required",
        loadingPleaseWait: "Loading... Please wait",
        successfullyGeneratedEUDRDeforestationStatus: "Successfully generated EUDR deforestation status.",
        successfullyUploadedToTheBlockchain : "Success! The EUDR Due Diligence Report has been successfully uploaded to the Blockchain.",
        compilanceRiskWarning: "Compliance Risk Warning",
        issueIdentifiedOnFarms: "Issues have been identified on some farms that need attention before proceeding to the next step. You may choose to address these issues now or continue to the next step and resolve them later.",
        blockchainDescs: [
          'Uploading report to blockchain, please wait...', 
          'Your Due Diligence report is being uploaded to blockchain. You will be redirected to the Due Diligence Reports list page to view the status.'
     ],
        reportDownloadedSuccessfully: "Report downloaded successfully!", 
        deleteProductionPlaceData: "Delete Production Place Data",
        areYouSureYouWantToContinueThisAction: "Are you sure you want to continue this action?",
        noAssessment: "No Assessments Found",
    
    
    
    
        uploadingToBlockchain: "Uploading report to blockchain, please wait...",
        beingUploadToBlockChain: 'Your Due Diligence report is being uploaded to blockchain. You will be redirected to the Due Diligence Reports list page to view the status.',
        uploading: "Uploading",
        attachFile: "Attach File",
        close: "Close",
        status: "Status",
        lotID: "Lot ID",
        noOfFarm: "No. Of Farms",
        processingDate: "Processing Date",
        origin: "Origin",
        selectUsingLots: "Select Production Places Using Lots",
        productionPlaceUsingFarms: "Select Production Places Using Farms",
        searchFarmName: "Search farm name",
        viewLocation: "View Geolocation",
        netMassKG: "Net Mass (kg)",
        volumeM3: "Volume (m3)",
        volumeM: "Volume",
        areaInHA: "Area (ha)",
        eudrUploadedToBlockChain: "Success! The EUDR Due Diligence Report has been successfully uploaded to the Blockchain.",
        viewDeforestationAssessment : "View Deforestation Assessment",
        viewDeforestationCertificate: "View Deforestation Certificate",
        selectCountries: "Select Countries",
        writingToBlockchain: "Writing to Blockchain",
    
    
        cattle: "Cattle",
        cocoa: "Cocoa",
        coffee: "Coffee",
        wood:"Wood",
        soya: "Soya",
        rubber: "Rubber",
        oilPlam: "Oil palm",
    
        subProduct1: "0102 21 , 0102 29 Live cattle",
        subProduct2: "0201 Meat of cattle, fresh or chilled",
        subProduct3: "0202 Meat of cattle, frozen",
        subProduct4: "0206 10 Edible offal of cattle, fresh or chilled",
        subProduct5: "0206 22 Edible cattle livers, frozen",
        subProduct6: "0206 29 Edible cattle offal (excluding tongues and livers), frozen",
        subProduct7: "1602 50 Other prepared or preserved meat, meat offal, blood, of cattle",
        subProduct8: "4101 Raw hides and skins of cattle (fresh, or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
        subProduct9: "4104 Tanned or crust hides and skins of cattle, without hair on, whether or not split, but not further prepared",
        subProduct10: "4107 Leather of cattle, further prepared after tanning or crusting, including parchment-dressed leather, without hair on, whether or not split, other than leather of heading 4114",
        subProduct11: "1801 Cocoa beans, whole or broken, raw or roasted",
        subProduct12: "1802 Cocoa shells, husks, skins and other cocoa waste",
        subProduct13: "1803 Cocoa paste, whether or not defatted",
        subProduct14: "1804 Cocoa butter, fat and oil",
        subProduct15: "1805 Cocoa powder, not containing added sugar or other sweetening matter",
        subProduct16: "1806 Chocolate and other food preparations containing cocoa",
        subProduct17: "0901 Coffee, whether or not roasted or decaffeinated; coffee husks and skins; coffee substitutes containing coffee in any proportion",
        subProduct18: "1207 10 Palm nuts and kernels",
        subProduct19: "1511 Palm oil and its fractions, whether or not refined, but not chemically modified",
        subProduct20: "1513 21 Crude palm kernel and babassu oil and fractions thereof, whether or not refined, but not chemically modified",
        subProduct21: "1513 29 Palm kernel and babassu oil and their fractions, whether or not refined, but not chemically modified (excluding crude oil)",
        subProduct22: "2306 60 Oilcake and other solid residues of palm nuts or kernels, whether or not ground or in the form of pellets, resulting from the extraction of palm nut or kernel fats or oils",
        subProduct23: "2905 45 Glycerol, with a purity of 95 % or more (calculated on the weight of the dry product)",
        subProduct24: "2915 70 Palmitic acid, stearic acid, their salts and esters",
        subProduct25: "2915 90 Saturated acyclic monocarboxylic acids, their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives (excluding formic acid, acetic acid, mono-, di- or trichloroacetic acids, propionic acid, butanoic acids, pentanoic acids, palmitic acid, stearic acid, their salts and esters, and acetic anhydride)",
        subProduct26: "3823 11 Stearic acid, industrial",
        subProduct27: "3823 12 Oleic acid, industrial",
        subProduct28: "3823 19 Industrial monocarboxylic fatty acids; acid oils from refining (excluding stearic acid, oleic acid and tall oil fatty acids)",
        subProduct29: "3823 70 Industrial fatty alcohols",
        subProduct30: "4001 Natural rubber, balata, gutta-percha, guayule, chicle and similar natural gums, in primary forms or in plates, sheets or strip",
        subProduct31: "4005 Compounded rubber, unvulcanised, in primary forms or in plates, sheets or strip",
        subProduct32: "4006 Unvulcanised rubber in other forms (e.g. rods, tubes and profile shapes) and articles (e.g. discs and rings)",
        subProduct33: "4007 Vulcanised rubber thread and cord",
        subProduct34: "4008 Plates, sheets, strips, rods and profile shapes, of vulcanised rubber other than hard rubber",
        subProduct35: "4010 Conveyer or transmission belts or belting, of vulcanised rubber",
        subProduct36: "4011 New pneumatic tyres, of rubber",
        subProduct37: "4012 Retreaded or used pneumatic tyres of rubber; solid or cushion tyres, tyre treads and tyre flaps, of rubber",
        subProduct38: "4013 Inner tubes, of rubber",
        subProduct39: "4015 Articles of apparel and clothing accessories (including gloves, mittens and mitts), for all purposes, of vulcanised rubber other than hard rubber",
        subProduct40: "4016 Other articles of vulcanised rubber other than hard rubber, not elsewhere specified in chapter 40",
        subProduct41: "4017 Hard rubber (e.g. ebonite) in all forms including waste and scrap; articles of hard rubber",
        subProduct42: "1201 Soya beans, whether or not broken",
        subProduct43: "1208 10 Soya bean flour and meal",
        subProduct44: "1507 Soya-bean oil and its fractions, whether or not refined, but not chemically modified",
        subProduct45: "2304 Oilcake and other solid residues, whether or not ground or in the form of pellets, resulting from the extraction of soya-bean oil",
        subProduct46: "4401 Fuel wood, in logs, in billets, in twigs, in faggots or in similar forms; wood in chips or particles; sawdust and wood waste and scrap, whether or not agglomerated in logs, briquettes, pellets or similar forms",
        subProduct47: "4402 Wood charcoal (including shell or nut charcoal), whether or not agglomerated",
        subProduct48: "4403 Wood in the rough, whether or not stripped of bark or sapwood, or roughly squared",
        subProduct49: "4404 Hoopwood; split poles; piles, pickets and stakes of wood, pointed but not sawn lengthwise; wooden sticks, roughly trimmed but not turned, bent or otherwise worked, suitable for the manufacture of walking sticks, umbrellas, tool handles or the like; chipwood and the like",
        subProduct50: "4405 Wood wool; wood flour",
        subProduct51: "4406 Railway or tramway sleepers (cross-ties) of wood",
        subProduct52: "4407 Wood sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, of a thickness exceeding 6 mm",
        subProduct53: "4408 Sheets for veneering (including those obtained by slicing laminated wood), for plywood or for other similar laminated wood and other wood, sawn lengthwise, sliced or peeled, whether or not planed, sanded, spliced or end-jointed, of a thickness not exceeding 6 mm",
        subProduct54: "4409 Wood (including strips and friezes for parquet flooring, not assembled) continuously shaped (tongued, grooved, rebated, chamfered, V-jointed, beaded, moulded, rounded or the like) along any of its edges, ends or faces, whether or not planed, sanded or end-jointed",
        subProduct55: "4410 Particle board, oriented strand board (OSB) and similar board (for example, waferboard) of wood or other ligneous materials, whether or not agglomerated with resins or other organic binding substances",
        subProduct56: "4411 Fibreboard of wood or other ligneous materials, whether or not bonded with resins or other organic substances",
        subProduct57: "4412 Plywood, veneered panels and similar laminated wood",
        subProduct58: "4413 Densified wood, in blocks, plates, strips or profile shapes",
        subProduct59: "4414 Wooden frames for paintings, photographs, mirrors or similar objects",
        subProduct60: "4415 Packing cases, boxes, crates, drums and similar packings, of wood; cable-drums of wood; pallets, box pallets and other load boards, of wood;",
        subProduct61: "pallet collars of wood(not including packing material used exclusively as packing material to support, protect or carry another product placed on the market)",
        subProduct62: "4416 Casks, barrels, vats, tubs and other coopers’ products and parts thereof, of wood, including staves",
        subProduct63: "4417 Tools, tool bodies, tool handles, broom or brush bodies and handles, of wood; boot or shoe lasts and trees, of wood",
        subProduct64: "4418 Builders’ joinery and carpentry of wood, including cellular wood panels, assembled flooring panels, shingles and shakes",
        subProduct65: "4419 Tableware and kitchenware, of wood",
        subProduct66: "4420 Wood marquetry and inlaid wood; caskets and cases for jewellery or cutlery, and similar articles, of wood; statuettes and other ornaments, of wood; wooden articles of furniture not falling in Chapter 94",
        subProduct67: "4421 Other articles of wood",
        subProduct68: "Pulp and paper of Chapters 47 and 48 of the Combined Nomenclature, with the exception of bamboo-based and recovered (waste and scrap) products",
        subProduct69: "49 Printed books, newspapers, pictures and other products of the printing industry, manuscripts, typescripts and plans, of paper",
        subProduct70: "9401 Seats (other than those of heading 9402 ), whether or not convertible into beds, and parts thereof, of wood",
        subProduct71: "9403 30 , 9403 40 , 9403 50 , 9403 60 and 9403 91 Wooden furniture, and parts thereof",
        subProduct72: "9406 10 Prefabricated buildings of wood",
    
        selectStatus: "Select Status",
        riskAssessmentNotApproved: "production places are not approved.",
    
        blockchainVerification: "Blockchain Verification",
        scanQrBlockchain: "Scan this QR code to view the EUDR Due Diligence Report on the blockchain.",
        downloadQrCode: "Download QR Code",
        eudrPublicReport: "Dimitra EUDR Due Diligence Public Report",
        scanQrEudr: "Scan this QR code to view the EUDR Due Diligence Report on public web.",
        viewReportForPublic: "Click Here to View Report for Public",
        viewReportOnBlockChain:"Click Here to View Report on Blockchain",
        declarationMissing: "Declaration Missing",

        removeRiskFarms: "REMOVE RISK FARMS",
        disregardRiskDocument: "DISREGARD RISK FARMS",
        attachRiskMitigationDocumentForNonCompliantFarms: "ATTACH RISK MITIGATION DOCUMENT FOR ALL NON-COMPLIANT FARMS",
        uploadMitigationDocumentForNonCompliantFarms: `Uploading a risk mitigation document for all non-compliant farms will change the status of farms with "Mitigation Required" to "Manually Mitigated".`,
        disregardFarmWithIssuesTitle:"Disregard Farms With Issues",
        disregardFarmWithIssuesMessage: "By selecting 'Disregard,' the missing risk assessment status for the  farms will not be considered in this report. The farms will remain part of the report, but their pending assessments will not impact the compliance status. Please confirm that you wish to proceed.",
        removeRiskFarmTitle: "Remove Farms ",
        removeRiskFarmMessage: "By selecting 'Remove,' the farms with risk assessment status 'Mitigation Required' or 'Rejected' will  be removed from this report. Please confirm that you wish to proceed.",

        fileName: "File Name",
        dateAndTime: "Date & Time",
        downloadProgressStatus: "Download Progress Status",
        downloadHistory: "Download History",
        downloaded: "Downloaded",
        inprogress: "In Progress",
        failed: "Failed",
        showAllDownloads: "Show All Downloads",
        inProgress: "In Progress",
        downloadCompleted: "Download Completed",
        downloadFailed: "Download Failed",
        errorDeletingItem: "Unable to delete the item. Please try again later.",
        anErrorOccuredPlsTryAgain: "Something went wrong. Please try again.",
        invalidData: "The data provided is invalid. Please check and try again.",
        fileIsReady: "File is ready to use",
        invalidFilePathOrUrl: "The file path or URL is invalid.",
        errorDownloadingFile: "There was an issue downloading the file. Please try again.",
        downloadInitiated: "Download initiated",
        beingDownloaded: " is now being downloaded. Estimated time",

        multiStepSurveyDetails:
        "Based on the number of questions in a step, all questions in the survey will be grouped and displayed in steps. However, this configuration is only available before adding questions or subheadings. Once a question or subheading is added, the Multi-Step configuration will be automatically disabled. Please remove any questions or subheadings to re-enable this option.",
        estimatedTime: "Estimated time",
        tryAgain: "Try Again",
        sendToOperator: "Send to Operator",
        expiryDate: "Expiry Date",
        selectDate: "Select Date",
        invalidCSVFile: "Invalid CSV file. Please check the file and try again.",
        missingColumnsExact: "Missing required columns: {columns}",
        validCSVFile: "CSV file is valid.",
        validExcelFile: "Excel file is valid.",
        invalidExcelFile: "Invalid Excel file. Please check the file and try again.",   
        finishStepsTooltip: "Finish Steps 1–3 by clicking ‘Next’ on each to unlock this tab.",
        viewDownloadHistory: "View Download History",
        eudrDocumentCodes: "EUDR Document Code(s)",
        referenceNumberForC717: "Reference Number for C717",
        exporterData: "Exporter Data",
        reportSharedSuccessfully: "Report shared successfully",
        shareReportWithExporter: "Share Report With Exporter",
        shareReadOnlyReport: "Share Read-Only Report",
        shareReportToOperator: "Share Report to Operator",
        verificationNumber: "Verification Number",
        dueDiligenceReport: "Due Diligence Report",
        productDetails: "Product Details",

        // Activity Log translations
        activityLog: "Activity Log",
        activityLogTT: "Activity log of actions taken on this report.",
        user: "User",
        userRole: "User Role",
        ipAddress: "IP Address",
        segment: "Segment",
        activityDescription: "Activity Description",
        statusHistory: "Status History",
        viewStatusHistory: "View Status History",
        dateTime: "Date & Time",
        expiresOn: "Expires on",
        failedToLoadHistory: "Failed to load status history",
        productionPlaceIdNotFound: "Production place ID not found",
        noHistoryFound: "No history found",

        accessAndVerify: "Access and Verify Due Diligence Reports",
        searchReportOrShipmentTitle: "Enter a Report ID or Shipment ID provided by the Exporter to review report details.",
        searchReportOrShipmentPlaceholder: "Search by Report ID or Shipment ID",
        reportStatus: "Report Status",
        assignedTo: "Assigned To",
        assignReports: "Assign Reports",
        approveReports: "Approve Reports",
        rejectReports: "Reject Reports",
        reportsSelected: "Reports Selected",
        daysOld: "Days Old",

        pleaseSelectUserToAssign: "Please select a user to assign the selected DDS reports. Once assigned, the user will be notified and granted access to manage these reports. You can reassign them later if needed.",
        chooseUserToAssign: "Choose a user to assign the selected reports to",
        assign: "Assign",


        // approval dashboard translations

        today: "Today",
        week: "Week",
        month: "Month",
        year: "Year",
        all: "All",
        selectDateRange: "Select Date Range",
        selectStartDate: "Select Start Date",
        selectEndDate: "Select End Date",
        apply: "Apply",
        activeCooperatives: "Active Cooperatives",
        activeUnionAgents:' Active Union',
        numberActiveCooperatives: "Number of active cooperatives in the system",
        numberActiveUnionAgents: "Number of active unions/agents in the system",
        activeExporters: "Active Exporters",
        activeAgent:'Active Agents',
        totalNumberRegisteredFarms: "Total number of registered farms in the system",
        registeredFarms: "Registered Farms",
        ddsCompliant: "DDS Compliant",
        numberDdsReportsCompliant: "Number of DDS reports that are compliant",
        ddsApproved: "DDS Approved",
        numberDdsReportsApproved: "Number of DDS reports that have been approved",
        ddsAssignedToMe: "DDS Assigned to Me",
        numberDdsReportsAssignedToMe: "Number of DDS reports assigned to me",
        ddsOverdue: "DDS Overdue",
        numberDdsReportsOverdue: "Number of DDS reports that are overdue",
        ddsNonCompliant: "DDS Non-Compliant",
        numberDdsReportsNonCompliant: "Number of DDS reports that are non-compliant",
        ddsRejected: "DDS Rejected",
        numberDdsReportsRejected: "Number of DDS reports that have been rejected",
        selectRegion: "Select Region",
        resetFilters: "Reset Filters",
        start: "Start",
        end: "End",
        date: "Date",
        averageProcessingTimeDays: "Average Processing Time (Days)",
        assignedEmployees: "Assigned Employees",
        reportsProcessed: "Reports Processed",
        averageTime: "Average Time",
        averageTimeToProcessDdsReport: "Average Time to Process DDS Report",
        filterBy: "Filter By",
        loadingChartData: "Loading chart data...",
        noDataAvailable: "No data available",
        ddsReports: "DDS Reports",
        comprehensiveViewOfAllDueDiligenceReportsAndTheirStatus: "Comprehensive view of all due diligence reports and their status",
        ddsReportSubmissions: "DDS Report Submissions",
        monthlyBreakdownOfDdsReportSubmissionsByStatus: "Monthly breakdown of DDS report submissions by status",
        ddsReportsByProducts: "DDS Reports by Products",
        ddsReportsByStatus: "DDS Reports by Status",  
        allProducts: "All Products",
        
        // Status labels for DDS Reports
        statusLabels: {
          pending_approval: "Pending Approval",
          overdue: "Overdue",
          approved: "Approved",
          rejected: "Rejected",
          processing: "Processing",
          compliant: "Compliant",
          non_compliant: "Non-Compliant",
          under_review: "Under Review",
          temporary_approved: "Temporary Approved",
          shipment_in_process: "Shipment In-Process"
        },
        numberActiveExporters: "Number of active exporters in the system",
        numberActiveAgents: "Number of active agents in the system",
        ddsReportsApproved: "DDS Reports Approved",
        pendingDdsReports: "Pending DDS Reports",
        overdueDdsReports: "Overdue DDS Reports",
        rejectedDdsReports: "Rejected DDS Reports",
        applyFilter: "Apply Filter",
        makeSelection: "Make Selection",

        assignToMe: "ASSIGN TO ME",
        assignToMeConfirmation: "Are you sure you want to assign this DDS report to yourself? Once assigned, you'll become responsible for reviewing and completing it.",
        assignToMeConfirmButton: "YES, ASSIGN TO ME",
        onlyReportsAssignedToYouCanBeSelected: "Only reports assigned to you can be selected",
        thisReportIsAssignedTo: "This report is assigned to {assignedUserName}. Only reports assigned to you can be selected.",
        thisReportIsNotAssignedToAnyoneOnlyReportsAssignedToYouCanBeSelected: "This report is not assigned to anyone. Only reports assigned to you can be selected.",
        noReportSelectedForAssignment: "No report selected for assignment",
        userInformationNotAvailable: "User information not available",

        checkingComplianceStatus: "Checking compliance status...",
        nonCompliantFarmsDetected: "Risk Detected Farms",
        approvalCompliantAndManuallyMitigated: "The report status will be changed to Compliant and Farms with issues or non-compliant status will be changed to Manually Mitigated.",
        approvalCompliantAndRiskDetected: "The report status will be changed to Compliant and farms with issues or risk detected status will be changed to Manually Mitigated.",
      

        additionalInformationRequested: "Additional Information Requested",
        supplierUpdates: "Supplier Updates",
        noDescriptionProvided: "No description provided",
        supplierHasRespondedAndMadeUpdates: "The supplier has responded to your request for additional information and made the following updates to this DDS report:",
        removedFarms: "Removed Farms",
        updatedFarms: "Updated Farms",
        addedNewFarms: "Added New Farms",
        noFarmChanges: "No farm changes",

        farmsAdded: "Farms Added",
        farmsRemoved: "Farms Removed",
        farmsUpdated: "Farms Updated",
        addressOfProduction: "Address of Production",
        
        // Production Place Expandable Row Translations
        locationStatus: "Location Status",
        viewFarm: "View Farm",
        locationStatusTT: "Verification status of the production place location coordinates and boundaries.",
        locationVerified: "Location Verified",
        locationError: "Location Error",
        geofenceError: "Geofence Error",
        farmOverlapped: "Farm Overlapped",
        countryMismatchError: "Country of Production is different from Farm Geofence Location.",
        circularFarmAreaTooLarge: "Circular Farm is more than 4.0 HA in Area.",
        farmOverlapMessage: "Farm geofence overlapped with another farm {farmName}",
        farmOverlapGeneric: "Farm geofence overlapped with another farm",
        dateOfIssue: "Date of Issue",
        dateOfExpiry: "Date of Expiry",
        documentExpiry: "Document Expiry",
        dateOfSubmission: "Date of Submission",
        assessments: "Assessments",
        riskAssessmentTT: "Risk assessment evaluates potential threats and compliance requirements for the production place.",
        noRiskAssessment: "No Risk Assessment Available",
        indigenousAndProtectedAreas: "Indigenous & Protected Areas",
        indigenousAndProtectedAreasTT: "Verification of whether the production place intersects with indigenous territories or protected areas.",
        interceptsProtectedArea: "Intercepts Protected Area",
        interceptsProtectedAreaTT: "Indicates whether the production place overlaps with any protected areas.",
        interceptsIndigenousArea: "Intercepts Indigenous Area",
        interceptsIndigenousAreaTT: "Indicates whether the production place overlaps with any indigenous territories.",
        mitigationDocuments: "Mitigation Documents",
        mitigationDocumentsTT: "Documents uploaded to demonstrate risk mitigation measures taken for the production place.",
        noMitigationDocuments: "No Mitigation Documents Available",
        mitigationComments: "Comments",
        noMitigationComments: "No comments available",
        showDetails: "Show Details",
        hideDetails: "Hide Details",
        ddsReportLog: "DDS Report Log",
        ddsReportLogTT: "DDS Report Log tracks various activities related to the DDS report itself",
        ddsApprovalLog: "DDS Approval Log",
        ddsApprovalLogTT: "DDS Approval Log logs activities related to the approval workflow of the DDS report",

        productAndQuantity: "Product & Quantity",
        buyingStationProcessor: "Buying Station / Processor",
        downloadPdfWithAccessKey: "Download PDF With Access Key",
        downloadPdfWithAccessKeyConfirmQuestion: "Are you sure you want to download this DDS report with an access code?",
        downloadPdfWithAccessKeyExplanation: "The access code allows the recipient to import this DDS data into their own account. They will have all information attached to the DDS. If you do not want to give full DDS access then download standard PDF without access code.",
        downloadPdfWithAccessKeyError: "Download failed. The server may not support PDF with access key yet.",
        ddsReportExchange: "DDS Report Exchange",
        importDdsReport: "Import DDS Report",
        exchangeRequests: "Exchange Requests",
        importDdsReportDescription: "If you are trading with an enterprise that also uses the Dimitra Due Diligence Platform, you can directly import their Due Diligence report. You can either enter the Internal Reference Number to send a request for approval or enter an Access Code provided by the enterprise for instant access. Once approved, the report will be available under the 'Due Diligence Report' section.",
        selectMethodOfImport: "Select Method of Import",
        requestInternalRefNumber: "Request Internal Request Number",
        iHaveAccessCode: "I have Access Code",
        accessCode: "Access Code",
        accessCodeTooltip: "Enter the access code provided by the enterprise to import their DDS report.",
        enterHere: "Enter here",
        internalRefRequestTooltip: "Enter the internal reference number to send a request to the enterprise.",
        accessTheReport: "ACCESS THE REPORT",
        exchangeRequestsTabDescription: "View and manage your DDS report exchange requests.",
        exchangeHistory: "Exchange History",
        exchangeHistoryDescription: "Below is the history of DDS reports you have imported from other enterprises via the Dimitra Due Diligence Platform. You can track the status of pending requests, view reports shared with you via Reference Number, or access reports unlocked using an Access Code.",
        incomingReportRequests: "Incoming Report Requests",
        incomingReportRequestsTooltip: "Report sharing requests sent to you by other users.",
        incomingReportRequestsDescription: "Here you can see all report sharing requests coming from other users. Please review the requests and approve or reject them. Approved requests grant access to full report.",
        ddsInternalReferenceNo: "DDS Internal Reference No.",
        productFilterTooltip: "Filter by product name or code.",
        requestApproved: "Request approved.",
        requestRejected: "Request rejected.",
        approve: "Approve",
        reject: "Reject",
        requestId: "Request ID",
        enterprise: "Enterprise",
        importMethod: "Import Method",
        requestStatus: "Request Status",
        requestIdDate: "Request ID / Date",
        requestingEnterpriseNameId: "Requesting Enterprise Name / ID",
        productQuantity: "Product/Quantity",
        dueDiligenceStatus: "Due Diligence Status",
        compliant: "Compliant",
        accessReportSuccess: "Report linked successfully. You can view it in Due Diligence Reports.",
        accessReportError: "Invalid or expired access code. Please check and try again.",
        exchangeHistoryLoadError: "Failed to load exchange history.",
        importingTitle: "Importing",
        importingMessage: "We are fetching the report data and synchronizing details with the blockchain. This may take a few moments. You can wait here, or check the status in your Exchange History.",
        cancelImport: "CANCEL IMPORT",
        runInBackground: "RUN IN BACKGROUND",
        checkExchangeHistory: "Import is running in the background. Check Exchange History for status.",
        requestSent: "Request sent successfully.",
        copied: "Copied",
        shareReport: "Share Report",
        shareReportWithInternalUser: "Share Report with Internal Dimitra User",
        shareReportWithInternalUserTooltip: "Share this report with a user registered in the Dimitra platform.",
        shareReportWithExternalUser: "Share Report with External User by Email",
        shareReportWithExternalUserTooltip: "Share this report with an external user via email.",
        enterUserEmail: "Enter User Email",
        userSearchError: "Failed to search user. You can still proceed with sharing.",
        pleaseEnterEmail: "Please enter an email address.",
        shareReportError: "Failed to share report. Please try again.",
        accessLevel: "Access Level",
        shareFullDataReport: "Share Full Data Report",
        shareFullDataReportDescription: "Generate Access Code, It will allow the recipient to import the DDS data in their own account.",
        iyb: {
          importSpreadsheetTitle: "Import IYB Score Spreadsheet",
          uploadFile: "Upload File",
          previewData: "Preview Data",
          confirmImport: "Confirm Import",
          uploadPtsiSpreadsheet: "Upload PTSI Spreadsheet",
          uploadDescription: "Upload the IYBv2 BOGOR spreadsheet provided by PTSI. This file contains the EUDR Risk Status and 13 indicator scores for all 514 Indonesian regencies.",
          acceptedFormats: "Accepted formats",
          or: "or",
          clickOrDragFileHere: "Click or drag & drop the IYBv2 BOGOR file here",
          acceptsCsvOrXlsx: "Accepts .csv or .xlsx",
          dataYear: "Data Year",
          selectYearHint: "Select the year this IYB data represents. Previous year data will be preserved.",
          previewImportData: "Preview Import Data",
          showingRows: "Showing {from} - {to} rows",
          totalRegenciesFound: "Total regencies found",
          records: "records",
          firePreventionTooltip: "Forest & Land Fires (IYBv2 BOGOR ind2). For Palm Oil: Red (≤40) blocks DDS submission.",
          lowRiskFastTrack: "Low Risk → GREEN (fast-track)",
          mediumRiskMitigation: "Medium Risk → YELLOW (mitigation)",
          highRiskAppealPath: "High Risk → RED (appeal path)",
          proceedToConfirm: "Proceed to Confirm",
          confirmImportDescription: "Importing will add or update IYB scores for {total} regencies for year {year}. Existing scores for other years will not be affected.",
          totalRegencies: "Total Regencies",
          importNow: "Import Now",
          regencyId: "Regency ID",
          regencyName: "Regency Name",
          iybScore: "IYB Score",
          firePrevention: "Fire Prevention",
          eudrRiskStatus: "EUDR Risk Status",
          iybScores: "IYB Scores",
          importSpreadsheet: "Import Spreadsheet",
          noDataFound: "No data found",
          noValidRegencyRows: "The spreadsheet did not contain any valid regency rows.",
          previewFailed: "Preview failed",
          couldNotParseSpreadsheet: "Could not parse spreadsheet",
          couldNotLoadPreviewPage: "Could not load preview page",
          importSuccessTitle: "IYB scores imported successfully",
          regenciesImported: "{count} regencies imported",
          importFailed: "Import failed",
          couldNotImportSpreadsheet: "Could not import spreadsheet",
          iybRegionalScores: "IYB Regional Scores",
          iybRegionalScoresSubtitle: "Regency-level Sustainable Jurisdiction Indicator scores sourced from PTSI. Used for Phase 2 of the EUDR Traffic Light compliance check.",
          allIndonesiaDistricts: "All Indonesia districts",
          greenLowRisk: "GREEN — Low Risk",
          fastTrackEligible: "Fast-track eligible",
          yellowMediumRisk: "YELLOW — Medium Risk",
          mitigationRequired: "Mitigation required",
          redHighRisk: "RED — High Risk",
          blockedAppealPath: "Blocked, appeal path available",
          searchRegencyName: "Search regency name...",
          filterByTier: "Filter by Tier",
          year: "Year",
          details: "Details",
          failedToLoadScores: "Failed to load IYB scores",
          indicatorBreakdownTitle: "IYB Indicator Breakdown",
          riskLabelZero: "Zero",
          notAvailable: "N/A",
          regencyKabupaten: "Regency / Kabupaten",
          environmental: "Environmental",
          socialAgricultural: "Social & Agricultural",
          governance: "Governance",
          scoreRanges: "Score ranges:",
          lowRiskRange: "Low Risk (≥60)",
          mediumRiskRange: "Medium Risk (40.01–59.99)",
          highRiskRange: "High Risk (≤40)",
          trafficLightPanel: {
            viewAssessmentConditions: "View assessment conditions",
            landAssessmentNotYetRun: "Land assessment not yet run",
            landAssessmentNotYetRunDesc: "Run verification to assess map-based polygon checks (100 m forest buffer) and district (Kabupaten) IYB score.",
            landPolygonAssessment: "Land Polygon Assessment",
            landPolygonAssessmentDesc: "Map-based analysis with 100 m forest boundary buffer",
            landPolygonAssessmentPreviewDesc: "Map-based deforestation, protected forest overlap & 100 m buffer analysis",
            districtAssessment: "District (Kabupaten) Assessment",
            districtAssessmentDesc: "Regency-level IYB sustainability index",
            showIndicators: "Show indicators",
            hideIndicators: "Hide indicators",
            unknownRegency: "Unknown Regency",
            localComplianceCheckIyb: "Local Compliance Check (IYB)",
            outOf100: "out of 100.00",
            noIybDataForRegency: "No IYB data for this regency",
            importIybToComplete: "Import IYB regional scores to complete assessment.",
            palmOilFirePreventionCheck: "Palm Oil — Fire Prevention Check",
            palmOilFirePreventionCheckDesc: "District-level Forest Fire Prevention indicator (IYBv2 BOGOR — ind2)",
            iybIndicatorScale: "IYBv2 BOGOR indicator (ind2) — 0–100 scale",
            palmOilDdsBlocked: "Palm Oil DDS Blocked — No Mitigation Pathway Available",
            palmOilDdsBlockedDesc: "This district is classified as Red for Forest Fire Prevention (indicator ≤ 40). Under the Palm Oil local compliance framework, no mitigation pathway exists. This DDS cannot proceed to PTSI submission for Palm Oil EU export.",
            firePreventionCheckPassed: "Fire Prevention Check Passed — Satellite Moisture Analysis Required",
            firePreventionCheckPassedGreen: "District meets fire prevention threshold (indicator ≥ 60). Proceed to satellite soil/vegetation moisture analysis.",
            firePreventionCheckPassedYellow: "District is in the medium fire prevention range (40–60). Satellite soil/vegetation moisture analysis is required before PTSI submission.",
            noFireIndicatorData: "No Forest & Land Fires indicator data for this district. Import IYB regional scores to enable the Palm Oil fire prevention check.",
            wildfireAlertTitle: "Wildfire Fire-Susceptibility Alert",
            wildfireAlertDesc: "Farm-level fire-risk report derived from satellite/weather data",
            wildfireAlertGenerated: "Report Generated",
            wildfireAlertLoading: "Checking for a generated wildfire alert...",
            wildfireAlertNotFound: "Not Generated",
            wildfireAlertNotFoundDesc: "No wildfire fire-susceptibility report has been generated for this production place yet.",
            wildfireAlertNoGeometry: "No Farm Boundary",
            wildfireAlertNoGeometryDesc: "No farm boundary or location data is available for this production place, so a fire-susceptibility report cannot be generated.",
            wildfireAlertGenerating: "Generating the fire-susceptibility report — this can take up to a few minutes on first request...",
            wildfireAlertSaving: "Saving fire-susceptibility report...",
            wildfireAlertReadyDesc: "Report generated — fire-susceptibility breakdown shown below",
            wildfireAlertClickToGenerate: "Click Generate to request the fire-susceptibility report for this farm",
            wildfireAlertGenerate: "Generate Report",
            wildfireAlertRegenerate: "Regenerate",
            wildfireAlertGenerateFailed: "Failed to generate the fire-susceptibility report. Please try again.",
            wildfireAlertAreaLabel: "Farm Area",
            wildfireAlertModelLabel: "Model",
            wildfireAlertPolygonBoundary: "Polygon Boundary",
            wildfireAlertCircularArea: "Circular Area",
            wildfireAlertGeneratedOn: "Generated",
            wildfireAlertRiskBreakdownTitle: "Risk Breakdown by Area",
            wildfireAlertHighestRisk: "Highest Risk",
            wildfireAlertRiskLevelColumn: "Risk Level",
            wildfireAlertAreaColumn: "Area (ha)",
            wildfireAlertShareColumn: "Share",
            wildfireAlertOverlayOpacity: "Overlay opacity",
            mitigationEvidence: "Mitigation Evidence",
            uploadedDocuments: "Uploaded documents",
            view: "View",
            remove: "Remove",
            clickToUploadOrDrop: "Click to upload or drag & drop",
            fileTypesMaxSize: "PDF, JPG, PNG, DOCX — max 10 MB each",
            ready: "Ready",
            failed: "Failed",
            uploadFailed: "Upload failed",
            uploadingToStorage: "Uploading file to secure storage... | Uploading files to secure storage...",
            submitEvidenceToPtsi: "Submit Evidence to PTSI",
            submittingToPtsi: "Submitting to PTSI...",
            fileExceedsLimit: "{name} exceeds 10 MB limit.",
            couldNotOpenMitigationDoc: "Could not open mitigation document.",
            mitigationDocument: "Mitigation document",
            fileCount: "{count} file | {count} files",
            phase1AllClear: "All Clear",
            phase1OneIssue: "1 Issue Found",
            phase1IssuesFound: "{count} Issues Found",
            fireRiskLow: "Fire Risk: Low",
            fireRiskMedium: "Fire Risk: Medium",
            blocked: "BLOCKED",
            lowRiskGte60: "Low Risk ≥60",
            mediumRisk: "Medium Risk",
            highRiskLte40: "High Risk ≤40",
            conditionsDocPalmOil: "Palm Oil — Local Compliance Addendum",
            conditionsDocCoffeeCocoa: "Coffee/Cocoa Addendum V2.1",
            legendFarmBoundary: "Farm boundary",
            legendDeforestation: "Deforestation",
            legendProtectedForest: "Protected forest",
            legend100mBuffer: "100m buffer",
            spatialDeforestationLabel: "Deforestation detected (post-2020)",
            spatialDeforestationShort: "Deforestation",
            spatialDeforestationHint: "Post-2020 forest loss",
            spatialForestOverlapLabel: "Protected / conservation forest overlap",
            spatialForestOverlapShort: "Forest Overlap",
            spatialForestOverlapHint: "Protected areas",
            spatialBufferLabel: "Within 100m of forest boundary",
            spatialBufferShort: "100m Buffer",
            spatialBufferHint: "Forest boundary proximity",
            chipDetected: "Detected",
            chipOverlap: "Overlap",
            chipWithin100m: "Within 100m",
            chipClear: "Clear",
            phase1TooltipTitle: "Phase 1 — {label}",
            checkpointResult: "Checkpoint result: {result}",
            spatialDeforestationFail: "Satellite analysis detected post-2020 forest loss inside the farm boundary. This is a critical spatial checkpoint and typically triggers high-risk classification.",
            spatialDeforestationPass: "No post-2020 forest loss was detected inside the farm boundary.",
            spatialForestOverlapFail: "The farm polygon overlaps a protected forest boundary (100 m buffer applied from forest edge). Future releases will integrate Indonesian map layers for hutan lindung, hutan sosial, and hutan masyarakat adat.",
            spatialForestOverlapPass: "No overlap with protected or conservation forest areas was detected within the 100 m boundary buffer.",
            spatialBufferWarn: "The farm boundary is within 100 m of a forest edge. Per assessment conditions, mitigation may be required even without direct deforestation.",
            spatialBufferPass: "The farm is outside the 100 m forest boundary buffer.",
            iybIndexUnavailable: "Regional sustainability index for {regency} is not available.",
            iybScoreSummary: "{regency} IYB score: {score} / 100.00 → {status}",
            regencyAssessed: "Regency assessed: {regency}",
            compositeIybScore: "Composite IYB score: {score} out of 100.00",
            scoreGreenFastTrack: "Score ≥ {min} — Green / fast-track eligible (low local risk)",
            scoreYellowMitigation: "Score {min}–{max} — Yellow / medium local risk (mitigation recommended)",
            scoreRedMandatory: "Score ≤ {max} — Light red / high local jurisdictional risk (mitigation mandatory)",
            regionalRiskStatus: "Regional risk status: {status}",
            indicatorBreakdownAvailable: "Indicator breakdown available — expand below for land cover, fire, peat, and other IYB factors",
            localComplianceNotLoaded: "Local compliance data has not been loaded for this farm.",
            mitigationNoteYellow: "This farm requires additional evidence before PTSI can approve the DDS. Upload mitigation documents — a 90-day window applies.",
            mitigationNoteRed: "Although classified as high risk, a mitigation pathway is available. Upload farm-level compliance evidence for PTSI review.",
            unknownRegencyLower: "Unknown regency",
          },
          indicators: {
            spatialPlanning: "Spatial Planning",
            forestLandFires: "Forest & Land Fires",
            waterWaste: "Water & Waste",
            climateAction: "Climate Action",
            landExploitation: "Land Exploitation",
            independentSmallholders: "Independent Smallholders",
            farmerInstitutions: "Farmer Institutions",
            businessPartnerships: "Business Partnerships",
            indigenousCommunities: "Indigenous Communities",
            gender: "Gender",
            spbeInformation: "SPBE Information",
            sp4nLaporComplaints: "SP4N-LAPOR Complaints",
            fpicSop: "FPIC SOP",
          },
        },
      },

      diligenceGuide: {
        guide: "Guide",
        downloadPdfManual: "Download PDF Manual",
        watchDemoVideo: "Watch Demo Video",
        viewManualOnWeb: "View Manual on Web",
      },

      welcomeScreenDiligenceGuide: {
        title: "Your Essential Guide Hub",
        description: `Explore our EUDR Due Diligence System Help Guides page for essential
        resources including PDF manuals, video tutorials, and web-based
        assistance. Empower yourself to navigate the platform efficiently
        and optimize your workflow.`,
        continueToTheDueDiligenceSystem: "Continue to the Due Diligence System",
      },

      containerTypes: {
        standardDry: "Standard Dry Container (20ft, 40ft)",
        highCube: "High Cube Container",
        openTop: "Open Top Container",
        flatRack: "Flat Rack Container",
        refrigerated: "Refrigerated Container (Reefer)",
        tank: "Tank Container",
        ventilated: "Ventilated Container",
        insulated: "Insulated Container",
        platform: "Platform Container",
        halfHeight: "Half-Height Container",
        bulk: "Bulk Container"
      },
              assessmentStatus:{
        riskAssessmentSummary: "Risk Assessment Summary",
        riskAssessmentSummaryTT: "Risk Assessment Summary",
        totalNoOfFarms: "Total No Of Farms ",
        assessmentsCompleted: "Assessment Completed",
        assessmentsPending:"Assessment Pending",
        requiredMitigation:"Required Mitigation"
      },
    supportedRegions: {
      title: "DDS Satellite Analysis — Supported Countries & Regions",
      description: "Deforestation satellite analysis is currently available for farms in the following countries and specific regions. Click a country to view its covered regions. If your production places are outside these areas, location verification data may be limited.",
      region: "region",
      regions: "regions",
      footer: "Coverage data is updated continuously. Contact support if your region is not listed.",
      showAll: "Show all {count} countries",
      showLess: "Show less"
    }
}